<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    id="email-app"
    class="flex w-full border border-solid d-theme-border-grey-light rounded relative overflow-hidden full-height vs-con-loading__container"
    :class="{
      'quotes-page-custom':
        currentContent.isQuotes && currentContent.quotesDisplayDetail,
      'main-menu-reduced': verticalNavMenuWidth == 'reduced',
      'custom-responsive-view': !isMosaicView && !isCalendarView,
      'refresh-active': refreshActive,
      'detail-over-list': isMaximizedDetail,
    }"
  >
    <!-- MOBILE FILTER CONTENT -->
    <vs-popup
      v-if="!isDesktop"
      title
      :active.sync="displayPopupContentFilterMobile"
      id="content-filter-mobile-popup"
      :style="insetStyle"
    >
      <menu-content-mobile
        :displayPopupContentFilterMobile="displayPopupContentFilterMobile"
        :contents="contents"
        :currentContentName="currentContentName"
        @displayExclusiveContent="displayExclusiveContent"
        @changeDisplayPopup="changeDisplayPopupContentFilterMobile"
        @updateHeaderMobileCurrentContent="updateHeaderMobileCurrentContent"
        @reloadDataWithFilter="reloadDataWithFilter"
        @close="
          displayPopupContentFilterMobile = !displayPopupContentFilterMobile
        "
        @updateFavoriteList="favoriteContentListMobile"
        @updateFilter="reloadDataWithFilter"
      ></menu-content-mobile>
      <div
        v-if="!isDesktop"
        class="v-nav-menu-swipe-area"
        v-hammer:swipe.right="onClose"
      ></div>
    </vs-popup>
    <!-- End of MOBILE FILTER CONTENT -->

    <!-- Mobile Informative sidebar -->
    <vs-sidebar
      v-if="!isDesktop"
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="informative-sidebar-filter sidebar-filter-mobile"
      spacer
      v-model="sidebarFilterActive"
      :click-not-close="true"
    >
      <informative-filter
        v-if="
          (filters.characteristic ||
            filters.periodicity ||
            filters.country ||
            filters.topic) &&
          sidebarFilterActive
        "
        ref="filter-page"
        :filterContent="selectedFilter"
        :characteristic="filters.characteristic"
        :periodicity="filters.periodicity"
        :country="filters.country"
        :exclusive="filters.exclusive"
        :topic="filters.topic"
        :reduceSidebar="reduceSidebar"
        :isConsulting="isConsulting"
        :isNews="isNews"
        :isWeather="isWeather"
        :isQuotes="isQuotes"
        :total="totalResults"
        :contents="contentList"
        @updateFilter="reloadDataWithFilter"
        @closeFilter="closeFilter"
        @open-author="openAuthorDetail"
        @open-register="openRegister"
      ></informative-filter>
    </vs-sidebar>
    <!-- End of Mobile Informative sidebar -->

    <!-- Desktop Sidebar Filter -->
    <vs-sidebar
      :class="{
        'sidebar-view-ticker-mosaic':
          isAuthenticated &&
          isDesktop &&
          isMosaicView &&
          canDisplayTicker &&
          !tickerViewAtTheTop,
        'sidebar-content-with-quotes':
          currentContent.isQuotes && currentContent.quotesDisplayDetail,
      }"
      v-if="isDesktop"
      class="items-no-padding info-sidebar-desktop"
      parent="#email-app"
      :reduce="reduceSidebar"
      :reduce-not-hover-expand="notExpand"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      v-model="isReportSidebarActive"
    >
      <informative-sidebar
        ref="informative-sidebar"
        v-if="displayFilters"
        :content="contentList"
        :reduceSidebar="reduceSidebar"
        :isAuthenticated="isAuthenticated"
        @openQuotesPage="openQuotesPage"
        @openQuotesPagePopup="openQuotesPagePopup"
        @toggleReduceSidebar="toggleReduceSidebar"
        @updateFilter="reloadDataWithFilter"
        @updateListContent="updateListContentFav"
        @open-user-rights-modal="openUserRightsModal"
        @open-exclusive-content="displayExclusiveContent"
      />
    </vs-sidebar>
    <!-- End of Desktop Sidebar Filter -->

    <div
      class="informative"
      :class="{
        'informative-sidebar-not-toggled':
          !reduceSidebar &&
          isDesktop &&
          !(displayQuotesPage || displayPublicQuotesPage) &&
          !(isMosaicView || isCalendarView),
        'informative-sidebar-toggled':
          reduceSidebar &&
          isDesktop &&
          !(displayQuotesPage || displayPublicQuotesPage) &&
          !(isMosaicView || isCalendarView),
      }"
    >
      <div
        class="informative-ticker-top"
        v-show="
          canDisplayTicker &&
          tickerViewAtTheTop &&
          isAuthenticated &&
          !isProfileFree
        "
        :class="{
          'content-menu-open informative-menu-margin-sidebar-open':
            isDesktop && (isMosaicView || isCalendarView) && !reduceSidebar,
          'content-menu-collapsed informative-menu-margin-sidebar-toggled':
            isDesktop && (isMosaicView || isCalendarView) && reduceSidebar,
          'w-full':
            isDesktop &&
            newsTickerData.length <= 0 &&
            !(isMosaicView || isCalendarView),
          'ticker-with-quotes':
            currentContent.isQuotes && currentContent.quotesDisplayDetail,
          'ticker-with-quotes-sidebar-toggled':
            reduceSidebar &&
            isDesktop &&
            currentContent.isQuotes &&
            currentContent.quotesDisplayDetail,
        }"
      >
        <!-- 'content-menu-open': isDesktop && !reduceSidebar,
          'content-menu-collapsed': isDesktop && reduceSidebar, -->
        <!-- 'informative-menu-margin-sidebar-open': isDesktop && (isMosaicView || isCalendarView) && !reduceSidebar,
          'informative-menu-margin-sidebar-toggled': isDesktop && (isMosaicView || isCalendarView) && reduceSidebar, -->
        <!-- 'width-informative-ticker-bottom': isDesktop && !reduceSidebar,
          'width-informative-ticker-bottom-menu-collapsed': isDesktop && reduceSidebar -->
        <tickers
          v-if="canDisplayTicker && tickerViewAtTheTop && isAuthenticated"
          :newsTickerData="newsTickerData"
          :isDesktop="isDesktop"
          :isAuthenticated="isAuthenticated"
          @openDetail="openDetail"
          @refreshTicker="loadReportTickers"
          @tickerViewOnPageTop="tickerViewOnPageTop"
          @tickerFilterImportantSelected="tickerFilterImportantSelected"
          @tickerFilterHighlightsSelected="tickerFilterHighlightsSelected"
        >
        </tickers>
      </div>
      <div
        id="list-and-view-informative"
        :class="{
          'height-informative':
            isAuthenticated && !tickerViewAtTheTop && canDisplayTicker,
          'informative-height-ticker-mosaic':
            isAuthenticated &&
            isDesktop &&
            (isMosaicView || isCalendarView) &&
            canDisplayTicker &&
            tickerViewAtTheTop,
        }"
      >
        <!-- 'informative-width': isDesktop && newsTickerData.length <= 0 && !(isMosaicView || isCalendarView), -->
        <!-- 'width-list-and-view-informative': isDesktop && !(isMosaicView || isCalendarView) && !reduceSidebar && canDisplayTicker, -->
        <!-- 'height-informative-content': !tickerViewAtTheTop, -->
        <div
          :class="{
            'cardview-desktop': isMosaicView || isCalendarView,
            'cardview-desktop-reduced':
              (isMosaicView || isCalendarView) && reduceSidebar,
            'sidebar-spacer': !reduceSidebar,
            'sidebar-spacer-toggled': reduceSidebar && isDesktop,
            'sidebar-spacer-toggled-content':
              reduceSidebar &&
              isDesktop &&
              (displayQuotesPage || displayPublicQuotesPage),
            'informative-content-mobile': !isDesktop,
            'informative-content-mobile-ask-analyst':
              !isDesktop &&
              canDisplayTicker &&
              !tickerViewAtTheTop &&
              displayAksAnalystPage,
            'info-content-desktop': isDesktop,
            'info-content-desktop-with-ticker-top':
              isDesktop &&
              canDisplayTicker &&
              tickerViewAtTheTop &&
              isAuthenticated &&
              !isProfileFree,
            'info-content-desktop-with-ticker':
              isAuthenticated &&
              isDesktop &&
              canDisplayTicker &&
              !tickerViewAtTheTop,
            'quotes-content-desktop':
              isDesktop && (displayQuotesPage || displayPublicQuotesPage),
            'whats-it-content': isWhatsItContent,
            'info-content-desktop-public': !isAuthenticated && isDesktop,
            'width-quotes-page-sidebar':
              isAuthenticated &&
              isDesktop &&
              !reduceSidebar &&
              (displayQuotesPage || displayPublicQuotesPage),
            'informative-calendar':
              isAuthenticated &&
              isDesktop &&
              isCalendarView &&
              canDisplayTicker &&
              tickerViewAtTheTop,
            'informative-calendar-without-ticker':
              isAuthenticated &&
              isDesktop &&
              isCalendarView &&
              !canDisplayTicker,
            'informative-calendar-with-ticker-mobile':
              isAuthenticated &&
              !isDesktop &&
              isCalendarView &&
              canDisplayTicker &&
              tickerViewAtTheTop,
          }"
          class="app-fixed-height border-r-0 border-t-0 border-b-0"
          id="informative-content"
        >
          <!-- 'cardview-desktop': isCardView,
            'info-content-desktop': isDesktop && (isListView || isListViewDetailed),
            'cardview-desktop-reduced': isCardView && reduceSidebar, -->
          <!-- <span v-show="displayQuotesPage" v-if="backgroundQuotesPage && isDesktop"> -->
          <!-- [2023-05-17] pedido para habilitar cotação no mobile -->
          <!-- <span v-show="currentContent.isQuotes && currentContent.quotesDisplayDetail" v-if="backgroundQuotesPage && isDesktop"> -->
          <div
            v-show="
              currentContent.isQuotes && currentContent.quotesDisplayDetail
            "
            v-if="backgroundQuotesPage"
            class="w-full h-full"
          >
            <TMNQuotes
              :currentCommodity="currentCommodity"
              :currentContent="currentContent"
              @detachSDK="detachSDK"
            ></TMNQuotes>
            <!-- <TMNQuotes
              :currentCommodity="commodityTitlePt"
              :currentContent="currentContent"
              @detachSDK="detachSDK"
            ></TMNQuotes> -->
          </div>
          <template
            v-if="
              currentContent.isQuotes &&
              !currentContent.quotesDisplayDetail &&
              isDesktop
            "
          >
            <div class="public-quotes-page h-full">
              <private-content @open-register="openRegister"></private-content>
            </div>
          </template>
          <template v-else-if="isWhatsItContent">
            <!-- <div
              class="informative-header all-commodities-header-empty"
              :style="headerStyle"
            >
              <span class="informative-background">
                <h1>{{commodityTitle}}</h1>
                <p class="informative-subtitle">{{currentContentName}}</p>
              </span>
            </div> -->
            <what-is-it :isDesktop="isDesktop"></what-is-it>
          </template>
          <template
            v-else-if="
              !displayQuotesPage &&
              !displayPublicQuotesPage &&
              !currentContent.isQuotes
            "
          >
            <!-- <div
              class="informative-header"
              :class="{'informative-header-empty': reportsData.length == 0, 'all-commodities-header-empty': (currentCommodity.id == 0 && isDesktop)}"
              :style="headerStyle"
              v-if="reportsData.length == 0"
            >
              <span class="informative-background">
                <h1>{{commodityTitle}}</h1>
                <p class="informative-subtitle">{{currentContentName}}</p>
              </span>
            </div> -->

            <div
              v-if="isDesktop"
              class="flex items-center src-bar vs-navbar p-1 vs-navbar-null vs-navbar-color-transparent"
            >
              <div
                class="search-field-content w-full"
                v-if="!displayAksAnalystPage"
              >
                <vx-tooltip
                  text="Clique para pesquisar"
                  position="bottom"
                  delay=".1s"
                  @click="openAuthorDetail(null)"
                >
                  <vs-input
                    icon-no-border
                    icon="icon-search"
                    size="large"
                    icon-pack="feather"
                    :placeholder="$t('REPORT_FILTER').Search"
                    v-model="searchQuery"
                    maxlength="128"
                    class="vs-input-no-border vs-input-no-shdow-focus w-full"
                    v-on:keyup.enter="searchAll()"
                    @focus="canFocusSearch"
                  />
                </vx-tooltip>
              </div>
              <div class="p-2 bg-white clear-search">
                <vx-tooltip text="Apagar" position="bottom" delay=".1s">
                  <feather-icon
                    v-if="searchQuery"
                    class="cursor-pointer close-icon"
                    icon="XIcon"
                    :svgClasses="['close-search']"
                    @click="clearSearchQuery"
                    tooltip="Deletar pesquisa"
                  ></feather-icon>
                </vx-tooltip>
              </div>

              <!-- desktop filter -->
              <!-- filter -->
              <!-- end desktop filter -->
              <div
                class="view-bar flex pointer items-center pr-3"
                v-if="!displayAksAnalystPage"
              >
                <!-- <div class="flex bar-icon ticker-eye-icon" v-if="isDesktop && !displayNotFountReportData && !displayAksAnalystPage && isAuthenticated">
                  <feather-icon
                    icon="EyeOffIcon"
                    class="viewbox-selected"
                    v-if="canDisplayTicker"
                    @click="changeDisplayTicker"
                  ></feather-icon>
                  <feather-icon
                    icon="EyeIcon"
                    class="viewbox-selected"
                    v-if="!canDisplayTicker"
                    @click="changeDisplayTicker"
                  ></feather-icon>
                </div> -->
                <div
                  class="bar-icon"
                  :class="{ 'view-style-selected': isListView }"
                >
                  <vx-tooltip
                    :text="$t('DISPLAY_TYPES').List"
                    position="bottom"
                    delay=".1s"
                  >
                    <feather-icon
                      icon="ListIcon"
                      :svgClasses="['pt-2']"
                      @click="listView"
                    ></feather-icon>
                  </vx-tooltip>
                </div>

                <div
                  v-if="!isCalendarContent"
                  class="bar-icon"
                  :class="{ 'view-style-selected': isListViewDetailed }"
                >
                  <vx-tooltip
                    :text="$t('DISPLAY_TYPES').Tag"
                    position="bottom"
                    delay=".1s"
                  >
                    <feather-icon
                      icon="ColumnsIcon"
                      :svgClasses="['pt-2 colum-invert']"
                      @click="listViewDetailed"
                    ></feather-icon>
                  </vx-tooltip>
                </div>

                <div
                  v-if="!isCalendarContent"
                  class="bar-icon"
                  :class="{ 'view-style-selected': isCardView }"
                >
                  <vx-tooltip
                    :text="$t('DISPLAY_TYPES').Card"
                    position="bottom"
                    delay=".1s"
                  >
                    <feather-icon
                      icon="GridIcon"
                      :svgClasses="['pt-2']"
                      @click="cardView"
                    ></feather-icon>
                  </vx-tooltip>
                </div>

                <div
                  v-if="!isCalendarContent"
                  class="bar-icon"
                  :class="{ 'view-style-selected': isMosaicView }"
                >
                  <vx-tooltip
                    :text="$t('DISPLAY_TYPES').Mosaic"
                    position="bottom"
                    delay=".1s"
                  >
                    <svg
                      viewBox="0 0 27 27"
                      class="fullscreenIcon"
                      :svgClasses="['pt-5 pl-2']"
                      @click="mosaicView"
                    >
                      <path
                        d="M6,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM16,6c0,1.1 0.9,2 2,2s2,-0.9 2,-2 -0.9,-2 -2,-2 -2,0.9 -2,2zM12,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2z"
                      ></path>
                    </svg>
                    <!-- <feather-icon icon="ChevronsRightIcon" ></feather-icon> -->
                  </vx-tooltip>
                </div>

                <div
                  v-if="isCalendarContent"
                  class="bar-icon"
                  :class="{ 'view-style-selected': isCalendarView }"
                >
                  <vx-tooltip
                    :text="$t('DISPLAY_TYPES').Calendar"
                    position="bottom"
                    delay=".1s"
                  >
                    <feather-icon
                      icon="CalendarIcon"
                      :svgClasses="['p-1']"
                      @click="changeToCalendarView"
                    ></feather-icon>
                  </vx-tooltip>
                </div>

                <div class="bar-division" v-if="isAuthenticated"></div>

                <div
                  class="bar-icon"
                  :class="{ 'dropdown-filter-visible': dropdownFilterVisible }"
                  v-if="isAuthenticated"
                >
                  <vx-tooltip text="Filtro" position="bottom" delay=".1s">
                    <vs-dropdown
                      vs-custom-content
                      vs-trigger-click
                      class="cursor-pointer desktop-btn-filter"
                      id="desktop-btn-filter"
                    >
                      <feather-icon
                        icon="FilterIcon"
                        :svgClasses="['pt-2']"
                      ></feather-icon>
                      <vs-chip
                        v-show="displayFilterBadgeSelected()"
                        class="number filter-badge-active"
                        color="primary"
                      ></vs-chip>
                      <vs-dropdown-menu
                        class="custom-dropdown-filter desktop-dropdown-filter"
                      >
                        <informative-filter
                          ref="filter-page"
                          :filterContent="selectedFilter"
                          :characteristic="filters.characteristic"
                          :periodicity="filters.periodicity"
                          :country="filters.country"
                          :exclusive="filters.exclusive"
                          :topic="filters.topic"
                          :isConsulting="isConsulting"
                          :isNews="isNews"
                          :isWeather="isWeather"
                          :isQuotes="isQuotes"
                          :total="totalResults"
                          :contents="contentList"
                          :isAuthenticated="isAuthenticated"
                          @updateFilter="reloadDataWithFilter"
                          @changeVisible="changeDropdownVisbile"
                          @open-author="openAuthorDetail"
                        ></informative-filter>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </vx-tooltip>
                </div>
                <div
                  class="bar-icon"
                  @click.stop="openPlaylist"
                  v-if="isAuthenticated && isDesktop"
                >
                  <vx-tooltip
                    :text="$t('DISPLAY_TYPES').Playlist"
                    position="bottom"
                    delay=".1s"
                  >
                    <feather-icon
                      icon="PlaylistIcon"
                      class="fullscreenIcon playlist-icon-informative"
                      :svgClasses="['pt-1 pl-1']"
                    />
                  </vx-tooltip>
                </div>
                <div
                  class="bar-icon"
                  @click.stop="openSchedule"
                  v-if="isAuthenticated && isDesktop"
                >
                  <vx-tooltip
                    :text="$t('DISPLAY_TYPES').Schedule"
                    position="bottom"
                    delay=".1s"
                  >
                    <feather-icon
                      icon="ArchiveIcon"
                      class="fullscreenIcon"
                      :svgClasses="['pt-1 pl-1']"
                    />
                  </vx-tooltip>
                </div>
                <div
                  class="bar-icon"
                  v-if="!isAuthenticated"
                  @click.stop="loadReportData"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="refresh-rotate-button"
                    width="18"
                    height="18"
                    :class="{ 'rotate-button': refreshActive }"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <polyline points="1 20 1 14 7 14"></polyline>
                    <path
                      d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                    ></path>
                  </svg>
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" class="rotate-button" width="18" height="18" :class="[refreshActive ? 'rotate-button' : '']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg> -->
                </div>
                <div
                  class="bar-icon"
                  v-if="isAuthenticated"
                  @click.stop="refreshReports"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="refresh-rotate-button"
                    width="18"
                    height="18"
                    :class="{ 'rotate-button': refreshActive }"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <polyline points="1 20 1 14 7 14"></polyline>
                    <path
                      d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                    ></path>
                  </svg>

                  <!-- <svg xmlns="http://www.w3.org/2000/svg" class="rotate-button" width="18" height="18" :class="[refreshActive ? 'rotate-button' : '']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg> -->
                </div>
              </div>
            </div>
            <!-- EMAILS LIST -->
            <div
              id="informative-scroll"
              class="email-content custom-content-scroll"
              :class="{
                'custom-content-scroll-mobile': !isDesktop,
                'custom-content-scroll-ticker-top':
                  isDesktop &&
                  canDisplayTicker &&
                  tickerViewAtTheTop &&
                  !isProfileFree,
                'custom-content-scroll-ticker-bottom':
                  isDesktop && canDisplayTicker && !tickerViewAtTheTop,
              }"
              ref="informative-scroll"
              @scroll="onScroll"
            >
              <!-- @scroll="onScroll" -->
              <!-- :suppressScrollX="true"
              :settings="settings"
              ref="mailListPS"
              @ps-scroll-y="scrollHandle"
              @ps-y-reach-end="scrollHandleToEnd" -->
              <!-- <div
                class="informative-header"
                :class="{'informative-header-desktop': isDesktop,'commodity-img-nav-scroll': changeScrollY, 'informative-header-desktop-sidebar-reduced': reduceSidebar, 'all-commodities-header-mobile': isImageHeaderAllCommotitiesAndMobile, 'all-commodities-header-desktop': (currentCommodity.id == 0 && isDesktop)}"
                :style="headerStyle"
              >
                <span
                  class="informative-background"
                  :class="{'informative-background-mobile': !isDesktop}"
                >
                  <h1>{{commodityTitle}}</h1>
                  <p class="informative-subtitle">{{currentContentName}}</p>
                </span>
              </div> -->

              <!-- TODO NEW FILTER -->
              <!-- <feather-icon class="cursor-pointer" icon="SearchIcon" :svgClasses="['h-5 w-5']" @click.stop="expandedFilter=!expandedFilter"></feather-icon> -->
              <!-- <div class="new-desktop-filter" v-if="isDesktop && expandedFilter && (isListView || isListViewDetailed)" :class="{'expanded-filter': expandedFilter}">
                <informative-filter
                  ref="dropdownfilter"
                  :filterContent="selectedFilter"
                  :characteristic="filters.characteristic"
                  :periodicity="filters.periodicity"
                  :country="filters.country"
                  :exclusive="filters.exclusive"
                  :isConsulting="isConsulting"
                  :isNews="isNews"
                  :isWeather="isWeather"
                  :isQuotes="isQuotes"
                  :total="totalResults"
                  :contents="contentList"
                  :isAuthenticated="isAuthenticated"
                  @updateFilter="reloadDataWithFilter"
                  @changeVisible="changeDropdownVisbile"
                ></informative-filter>
              </div> -->

              <!-- <div class="view-mode" v-if="!isDesktop">
                  <span class="icons-tools-wrap icons-tools-wrap-mobile btn-left" :class="{'view-style-selected-mobile': isListView}" @click.stop="listView">
                    Lista
                  </span>

                  <span class="icons-tools-wrap icons-tools-wrap-mobile btn-left" :class="{'view-style-selected-mobile': isListViewDetailed}" @click.stop="listViewDetailed">
                    Card
                  </span>
                </div> -->

              <!-- HERE DESKTOP SEARCHBAR -->
              <!-- !! -->
              <div
                v-if="
                  hasHighlights && !displayAksAnalystPage && !isCalendarView
                "
                :class="{ 'highlight-mobile': !isDesktop }"
              >
                <!-- 'report-list-with-highliths': hasHighlights -->
                <div
                  class="header-home home-title cursor-pointer"
                  @click="changeCollapseHighlights"
                >
                  <div class="flex w-full">
                    <span>{{ $t("HIGHLIGHTS").Highlights }}</span>
                    <feather-icon
                      :icon="
                        highlightCollapsed ? 'ChevronDownIcon' : 'ChevronUpIcon'
                      "
                      class="cursor-pointer highlight-title-icon-collapsed ml-1"
                      size="20"
                    ></feather-icon>
                  </div>
                  <div style="display: flex">
                    <!-- <div class="viewbody flex" v-if="!isDesktop && !displayNotFountReportData && !displayAksAnalystPage && isAuthenticated">
                      <feather-icon
                        icon="EyeOffIcon"
                        class="viewbox-selected"
                        v-if="canDisplayTicker"
                        @click="changeDisplayTicker"
                      ></feather-icon>
                      <feather-icon
                        icon="EyeIcon"
                        class="viewbox-selected"
                        v-if="!canDisplayTicker"
                        @click="changeDisplayTicker"
                      ></feather-icon>
                    </div> -->
                    <div
                      class="viewbody flex"
                      style="margin-right: 10px"
                      v-if="
                        !isDesktop &&
                        !displayNotFountReportData &&
                        !displayAksAnalystPage
                      "
                    >
                      <!-- class="viewbodyicons" -->
                      <feather-icon
                        icon="ListIcon"
                        class="viewbox-selected"
                        v-if="
                          isTabletResolution ? isMosaicView : isListViewDetailed
                        "
                        @click.stop="listView"
                      ></feather-icon>
                      <feather-icon
                        class="viewbox-selected"
                        icon="ColumnsIcon"
                        v-if="isListView"
                        @click.stop="listViewDetailed"
                      ></feather-icon>
                      <feather-icon
                        class="viewbox-selected"
                        icon="GridIcon"
                        v-if="isTabletResolution && isListViewDetailed"
                        @click.stop="mosaicView"
                      ></feather-icon>
                    </div>
                  </div>
                  <!-- <div class="viewbody flex-update" style="margin-right: 13px;" @click.stop="refreshReports" v-if="isAuthenticated && !isDesktop">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" :class="[refreshActive ? 'rotate-button' : '']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                  </div> -->
                  <!-- <div class="viewbody flex-update" style="margin-right: 13px;" @click.stop="loadReportData" v-if="!isAuthenticated && !isDesktop">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" :class="[refreshActive ? 'rotate-button' : '']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                  </div> -->
                </div>

                <div class="highlights-view" v-show="!highlightCollapsed">
                  <transition-group
                    v-if="canDisplayHighlight && isListView"
                    name="list-enter-up"
                    class="email__mails"
                    tag="ul"
                    appear
                  >
                    <li
                      class="cursor-pointer email__mail-item mb-1"
                      v-for="(report, index) in reportsDataHighlights"
                      :key="index + 1"
                      @click.stop="openDetail(report)"
                      :class="{
                        highlight: isListView,
                        'list-item-selected': isItemSelected(report),
                      }"
                    >
                      <!-- :style="{transitionDelay: (index * 0.01) + 's'}" -->
                      <informative-list-item
                        :schedule="isCalendarContent"
                        :data="report"
                        :isDesktop="isDesktop"
                        :currentCommodity="currentCommodity"
                        :contentId="currentContent.id"
                        :isAuthenticated="isAuthenticated"
                        @playMultimedia="playMultimedia"
                        @openDetail="openDetail"
                        @open-author="openAuthorDetail"
                        @onDownloadFile="onDownloadFile"
                        @open-exclusive-content="displayExclusiveContent"
                        @save-schedule-news="saveScheduleNews"
                      />
                    </li>
                  </transition-group>
                </div>

                <!-- <informative-highlights v-if="canDisplayHighlight && isListViewDetailed"
                  :reports="reportsDataHighlights"
                  :currentCommodity="currentCommodity"
                  :currentSelected="reportDetail"
                  v-on:openReportDetail="openDetail"
                  @open-author="openAuthorDetail"
                  @playMultimedia="playMultimedia"
                  @onDownloadFile="onDownloadFile"
                  @open-exclusive-content="displayExclusiveContent"
                ></informative-highlights> -->
                <informative-highlights-mosaic
                  ref="highlight-component"
                  v-if="
                    canDisplayHighlight &&
                    (isListViewDetailed ||
                      isCardView ||
                      isMosaicView ||
                      isCalendarView) &&
                    !highlightCollapsed
                  "
                  :data="reportsDataHighlights"
                  :currentCommodity="currentCommodity"
                  :currentSelected="reportDetail"
                  :isAuthenticated="isAuthenticated"
                  v-on:openReportDetail="openDetail"
                  @open-author="openAuthorDetail"
                  @playMultimedia="playMultimedia"
                  @onDownloadFile="onDownloadFile"
                  @open-exclusive-content="displayExclusiveContent"
                  @save-schedule-news="saveScheduleNews"
                ></informative-highlights-mosaic>
                <!-- <informative-highlights-fullscreen v-if="canDisplayHighlight && isMosaicView"
                  :data="reportsDataHighlights"
                  :currentCommodity="currentCommodity"
                  :currentSelected="reportDetail"
                  v-on:openReportDetail="openDetail"
                  @open-author="openAuthorDetail"
                  @playMultimedia="playMultimedia"
                  @onDownloadFile="onDownloadFile"
                  @open-exclusive-content="displayExclusiveContent"
                ></informative-highlights-fullscreen> -->
              </div>

              <!-- @ps-y-reach-end="scrollHandleToEnd" -->
              <div class="flex justify-between header-home">
                <div class="lbl-home flex w-full">
                  <feather-icon
                    :icon="currentCommodity.icone"
                    class="cursor-pointer"
                    svg-classes="icon-breadcrumb"
                  />
                  <div class="name-breadcrumb">
                    {{ currentCommodityNameTitle }} — {{ lastPublishName }}
                  </div>
                </div>
                <!-- <div class="viewbody flex" v-if="!isDesktop && !displayNotFountReportData && !displayAksAnalystPage && isAuthenticated">
                  <feather-icon
                    icon="EyeOffIcon"
                    class="viewbox-selected"
                    v-if="canDisplayTicker"
                    @click="changeDisplayTicker"
                  ></feather-icon>
                  <feather-icon
                    icon="EyeIcon"
                    class="viewbox-selected"
                    v-if="!canDisplayTicker"
                    @click="changeDisplayTicker"
                  ></feather-icon>
                </div> -->
                <div
                  class="viewbody flex"
                  style="margin-right: 10px"
                  v-if="
                    !isDesktop &&
                    !displayNotFountReportData &&
                    !displayAksAnalystPage
                  "
                >
                  <!-- class="viewbodyicons" -->
                  <feather-icon
                    icon="ListIcon"
                    class="viewbox-selected"
                    v-if="
                      isTabletResolution ? isMosaicView : isListViewDetailed
                    "
                    @click.stop="listView"
                  ></feather-icon>
                  <feather-icon
                    class="viewbox-selected"
                    icon="ColumnsIcon"
                    v-if="isListView"
                    @click.stop="listViewDetailed"
                  ></feather-icon>
                  <feather-icon
                    class="viewbox-selected"
                    icon="GridIcon"
                    v-if="isTabletResolution && isListViewDetailed"
                    @click.stop="mosaicView"
                  ></feather-icon>
                  <!-- <div class="viewbody flex-update" @click.stop="refreshReports" v-if="isAuthenticated && !isDesktop && !displayAksAnalystPage">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" :class="[refreshActive ? 'rotate-button' : '']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                  </div>
                  <div class="viewbody flex-update" @click.stop="loadReportData" v-if="!isAuthenticated && isDesktop && !displayAksAnalystPage">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" :class="[refreshActive ? 'rotate-button' : '']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                  </div> -->
                </div>
              </div>

              <div
                class="w-full informative-div"
                v-if="isListView || isListViewDetailed"
              >
                <!-- List view -->
                <transition-group
                  name="list-enter-up"
                  class="email__mails"
                  tag="ul"
                  appear
                  :class="{
                    'report-list-no-highliths mb-1':
                      !hasHighlights && isDesktop,
                  }"
                >
                  <li
                    class="cursor-pointer email__mail-item mb-1"
                    v-for="(report, index) in reportsData"
                    :key="index + 1"
                    :id="report._id"
                    @click.stop="openDetail(report)"
                    :class="{
                      'list-item-selected': isItemSelected(report),
                      'mb-2': isListViewDetailed,
                    }"
                  >
                    <!-- :style="{transitionDelay: (index * 0.01) + 's'}" -->
                    <informative-item
                      v-if="isListViewDetailed"
                      :data="report"
                      :isDesktop="isDesktop"
                      :isAuthenticated="isAuthenticated"
                      :currentCommodity="currentCommodity"
                      :class="{ highlight: isListView }"
                      :contentId="currentContent.id"
                      @open-exclusive-content="displayExclusiveContent"
                      @playMultimedia="playMultimedia"
                      @openDetail="openDetail"
                      @open-author="openAuthorDetail"
                      @onDownloadFile="onDownloadFile"
                      @filter="onFilterFromTag"
                      @save-schedule-news="saveScheduleNews"
                    />
                    <informative-list-item
                      v-if="isListView"
                      :schedule="isCalendarContent"
                      :data="report"
                      :isDesktop="isDesktop"
                      :isAuthenticated="isAuthenticated"
                      :currentCommodity="currentCommodity"
                      :class="{ highlight: isListView }"
                      :contentId="currentContent.id"
                      @open-exclusive-content="displayExclusiveContent"
                      @playMultimedia="playMultimedia"
                      @openDetail="openDetail"
                      @open-author="openAuthorDetail"
                      @onDownloadFile="onDownloadFile"
                      @filter="onFilterFromTag"
                      @save-schedule-news="saveScheduleNews"
                    />
                  </li>

                  <li
                    v-if="displayNotFountReportData"
                    class="mb-2"
                    key="09721738"
                  >
                    <div class="empty-report report-0-1" v-if="isAuthenticated">
                      <feather-icon
                        icon="SearchIcon"
                        class="cursor-pointer"
                        svg-classes="h-10 w-10"
                      />
                      <h3>{{ $t("REPORT").No_Report_Found }}</h3>
                      <h6>{{ $t("REPORT").No_Report_Found_Text }}</h6>
                    </div>

                    <div
                      class="empty-report empty-users"
                      v-if="!isAuthenticated"
                    >
                      <feather-icon
                        icon="LockIcon"
                        class="cursor-pointer"
                        svg-classes="h-10 w-10"
                      />
                      <h3>
                        <a @click.stop="openLogin" class="cursor-pointer">{{
                          $t("REPORT").No_Report_Found_Text_Demo
                        }}</a>
                      </h3>
                    </div>
                  </li>
                </transition-group>

                <!-- End List view -->
              </div>

              <!-- Card view -->
              <!-- <div style="margin-top: 140px" v-if="isDesktop && !hasHighlights && isCardView"></div> -->
              <!-- <div style="margin-top: 140px" v-if="isDesktop && !hasHighlights && isCardView"></div> -->

              <vs-row vs-w="12" v-if="isCardView">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  :vs-lg="cardViewNumCard"
                  :vs-sm="cardViewNumCard"
                  :vs-xs="cardViewNumCard"
                  v-for="(report, index) in reportsData"
                  :key="index + 1"
                  :id="report._id"
                  :class="{ 'list-item-selected': isItemSelected(report) }"
                >
                  <informative-card-item
                    ref="card-item"
                    @openDetailParent="openDetail"
                    :data="report"
                    :isDesktop="isDesktop"
                    :contentId="currentContent.id"
                    :currentCommodity="currentCommodity"
                    :isAuthenticated="isAuthenticated"
                    @open-exclusive-content="displayExclusiveContent"
                    @playMultimedia="playMultimedia"
                    @onDownloadFile="onDownloadFile"
                    @open-author="openAuthorDetail"
                    @filter="onFilterFromTag"
                    @save-schedule-news="saveScheduleNews"
                  />
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  :vs-lg="12"
                  :vs-sm="12"
                  vs-xs="12"
                  v-if="displayNotFountReportData"
                >
                  <div class="empty-report report-0-1" v-if="isAuthenticated">
                    <feather-icon
                      icon="SearchIcon"
                      class="cursor-pointer"
                      svg-classes="h-10 w-10"
                    />
                    <h3>{{ $t("REPORT").No_Report_Found }}</h3>
                    <h6>{{ $t("REPORT").No_Report_Found_Text }}</h6>
                  </div>

                  <div class="empty-report empty-users" v-if="!isAuthenticated">
                    <feather-icon
                      icon="LockIcon"
                      class="cursor-pointer"
                      svg-classes="h-10 w-10"
                    />
                    <h3>
                      <a @click.stop="openLogin" class="cursor-pointer">{{
                        $t("REPORT").No_Report_Found_Text_Demo
                      }}</a>
                    </h3>
                  </div>
                </vs-col>
              </vs-row>
              <vs-row vs-w="12" v-if="isMosaicView && reportsData.length > 0">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  :vs-lg="numCardsMosaic"
                  :vs-sm="numCardsMosaic"
                  v-for="(report, index) in reportsData"
                  :key="index + 1"
                  :id="report._id"
                  :class="{ 'list-item-selected': isItemSelected(report) }"
                >
                  <informative-mosaic-item
                    ref="card-item"
                    @openDetailParent="openDetail"
                    :data="report"
                    :isDesktop="isDesktop"
                    :contentId="currentContent.id"
                    :currentCommodity="currentCommodity"
                    :isAuthenticated="isAuthenticated"
                    @open-exclusive-content="displayExclusiveContent"
                    @playMultimedia="playMultimedia"
                    @onDownloadFile="onDownloadFile"
                    @open-author="openAuthorDetail"
                    @filter="onFilterFromTag"
                    @save-schedule-news="saveScheduleNews"
                  />
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  :vs-lg="12"
                  :vs-sm="12"
                  vs-xs="12"
                  v-if="displayNotFountReportData"
                >
                  <div class="empty-report report-0-1" v-if="isAuthenticated">
                    <feather-icon
                      icon="SearchIcon"
                      class="cursor-pointer"
                      svg-classes="h-10 w-10"
                    />
                    <h3>{{ $t("REPORT").No_Report_Found }}</h3>
                    <h6>{{ $t("REPORT").No_Report_Found_Text }}</h6>
                  </div>

                  <div class="empty-report empty-users" v-if="!isAuthenticated">
                    <feather-icon
                      icon="LockIcon"
                      class="cursor-pointer"
                      svg-classes="h-10 w-10"
                    />
                    <h3>
                      <a @click.stop="openLogin" class="cursor-pointer">{{
                        $t("REPORT").No_Report_Found_Text_Demo
                      }}</a>
                    </h3>
                  </div>
                </vs-col>
              </vs-row>

              <div v-if="isCalendarView" class="calendar-wrap">
                <!-- <informative-calendar></informative-calendar> -->
                <!-- <b-button
                  size="sm"
                  class="btn-icon btn-close"
                  variant="flat-primary"
                  @click="testCalendarApi"
                >
                  testeeeeeee
                </b-button> -->
                <Calendar
                  ref="calendarComponent"
                  @open-detail="openDetail"
                  @update-data="updateDataFromCalendar"
                  :selectedFilter="selectedFilter"
                ></Calendar>
              </div>
              <!-- End Card view -->

              <div
                id="load-more-loading"
                class="vs-con-loading__container load-more-loading-area"
                v-if="showLoadMorePage && !displayLoadInBtn"
              ></div>

              <div
                class="content-btn-informative-back-to-top"
                :class="{
                  'fade-in': displayBackToTopBtn,
                  'fade-out': !displayBackToTopBtn,
                  'ticker-top': canDisplayTicker && tickerViewAtTheTop,
                  'ticker-bottom': canDisplayTicker && !tickerViewAtTheTop,
                }"
              >
                <vs-button
                  v-if="
                    displayBackToTopBtn &&
                    reportsData.length > 0 &&
                    !isCalendarView
                  "
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                  @click.stop="onBackToTop()"
                />
              </div>
            </div>

            <!-- <div v-if="!isReportViewSidebarActive && !displayAksAnalystPage">
              <p>Selecione um item ao lado para ler</p>
              <p>Nada selecionado</p>
            </div> -->
          </template>
          <!--      <template v-show="displayQuotesPage">-->
          <!--        <TMNQuotes-->
          <!--          :currentCommodity="commodityTitle"-->
          <!--          :currentContent="currentContent.nome"/>-->
          <!--      </template>-->
        </div>

        <div
          id="view-detail"
          v-show="!isWhatsItContent && !currentContent.isQuotes"
          @click="openAuthorDetail(null)"
        >
          <informative-view
            ref="informative-view"
            :isConsulting="isConsulting"
            :isNews="isNews"
            :detail="reportDetail"
            :reduceFilterSidebar="reduceSidebar"
            :isSidebarActive="isReportViewSidebarActive"
            :currentCommodity="currentCommodity"
            :isMaximizedDetail="isMaximizedDetail"
            :displayWeatherPage="displayWeatherPage"
            @openRelatedNews="loadNewsDetail"
            @closeSidebar="closeReportViewSidebar"
            @openEventScheduleRelatedNews="loadEventScheduleRelatedNews"
            @onDownloadFile="onDownloadFile"
            @open-author="openAuthorDetail"
            @filter="onFilterFromTag"
            @open-register="openRegister"
            @open-image-mobile="openImageMobile"
            @maximize-detail="maximizeDetail"
            @save-schedule-news="saveScheduleNews"
          ></informative-view>
        </div>
      </div>
      <div
        class="informative-ticker-bottom"
        v-show="
          canDisplayTicker &&
          !tickerViewAtTheTop &&
          isAuthenticated &&
          !isProfileFree
        "
        :class="{
          'content-menu-open informative-menu-margin-sidebar-open':
            isDesktop && (isMosaicView || isCalendarView) && !reduceSidebar,
          'content-menu-collapsed informative-menu-margin-sidebar-toggled':
            isDesktop && (isMosaicView || isCalendarView) && reduceSidebar,
          'w-full':
            isDesktop &&
            newsTickerData.length <= 0 &&
            !(isMosaicView || isCalendarView),
          'ticker-with-quotes':
            currentContent.isQuotes && currentContent.quotesDisplayDetail,
          'ticker-with-quotes-sidebar-toggled':
            reduceSidebar &&
            isDesktop &&
            currentContent.isQuotes &&
            currentContent.quotesDisplayDetail,
        }"
      >
        <!--
          'informative-menu-margin-sidebar-open': isDesktop && (isMosaicView || isCalendarView) && !reduceSidebar,
          'informative-menu-margin-sidebar-toggled': isDesktop && (isMosaicView || isCalendarView) && reduceSidebar,
          'informative-width': isDesktop && newsTickerData.length <= 0 && !(isMosaicView || isCalendarView),
          'width-informative-ticker-bottom': isDesktop && !reduceSidebar,
          'width-informative-ticker-bottom-menu-collapsed': isDesktop && reduceSidebar,
          'informative-ticker-bottom-mosaic': isDesktop && (isMosaicView || isCalendarView) && canDisplayTicker && !tickerViewAtTheTop, -->
        <tickers
          v-if="canDisplayTicker && !tickerViewAtTheTop && isAuthenticated"
          :newsTickerData="newsTickerData"
          :isDesktop="isDesktop"
          :isAuthenticated="isAuthenticated"
          @openDetail="openDetail"
          @refreshTicker="loadReportTickers"
          @tickerViewOnPageTop="tickerViewOnPageTop"
          @tickerFilterImportantSelected="tickerFilterImportantSelected"
          @tickerFilterHighlightsSelected="tickerFilterHighlightsSelected"
        >
        </tickers>
      </div>
    </div>

    <ask-the-analyst
      v-if="displayAksAnalystPage"
      :isDesktop="isDesktop"
      :currentCommodity="currentCommodity"
      :commodityName="commodityTitle"
      :currentContent="previousContent"
      :reduceFilterSidebar="reduceSidebar"
      :isSidebarActive="displayAksAnalystPage"
      @backPage="onBackAnalystPage"
    ></ask-the-analyst>
  </div>
</template>

<script>
import InformativeSidebar from "./InformativeSidebar.vue";
import InformativeItem from "./InformativeItem.vue";
import InformativeListItem from "./InformativeListItem.vue";
import InformativeCardItem from "./InformativeCardItem.vue";
import InformativeMosaicItem from "./InformativeMosaicItem.vue";
import InformativeFilter from "./InformativeFilter.vue";
import InformativeView from "./InformativeView.vue";
import InformativeHighlights from "./InformativeHighlights.vue";
import InformativeHighlightsMosaic from "./InformativeHighlightsMosaic.vue";
import InformativeHighlightsFullscreen from "./InformativeHighlightsFullscreen.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import reportService from "../../../providers/reportService";
import AppConstants from "../../../appConstants";
import convertDatetimeHelper from "../../../helpers/convert-datetime-helper";
import { EventBus } from "../../../event-bus";
import AskTheAnalyst from "../analyst/AskTheAnalyst.vue";
import TMNQuotes from "../quotes/TMNQuotes.vue";
import localStorageHelper from "../../../helpers/local-storage-helper";
import { CONTENT } from "../../../enums/enum-content";
import DropdownUserInfo from "../widgets/dropdown-user-info/DropdownUserInfo.vue";
import tmnHelper from "../../../helpers/tmn-helper";
import layoutService from "@/providers/layoutService";
import messageDialogHelper from "../../../helpers/message-dialog-helper";
import { getCodeLang } from "@/helpers/locale-helper";
import WhatIsIt from "../whatsit/WhatIsIt.vue";
import newsHomeService from "../../../providers/newsHomeService";
import translateFieldHelper from "../../../helpers/translate-field-helper";
import menuBuilderHelper from "../../../helpers/menu-builder-helper";
import CustomContent from "../CustomContent.vue";
import checkDeviceTypeHelper from "../../../helpers/check-device-type-helper";
import PrivateContent from "../private-content/PrivateContent.vue";
import VuePullRefresh from "vue-pull-refresh";
import { getLocaleCode } from "@/helpers/locale-helper";
import messagesNotifyHelper from "../../../helpers/messages-notify-helper";
import MenuContentMobile from "./MenuContentMobile.vue";
import generalHelper from "../../../helpers/general-helper";
import InformativeSidebarVue from "./InformativeSidebar.vue";
import InformativeCalendar from "./InformativeCalendar.vue";
import Calendar from "../calendar-events/Calendar";
import { BButton } from "bootstrap-vue";
import Tickers from "./Tickers.vue";
import biometryHelper from "../../../helpers/biometry-helper";
import { getInsetStyle } from "../../../helpers/inset-style-helper";
// import WeatherPage from "../weather/WeatherPage.vue";

export default {
  data() {
    return {
      mobileContentListTabIndex: 0,
      pullRefreshConfig: {
        startLabel: "",
        readyLabel: "",
        loadingLabel: "Loading...",
        errorLabel: "Error on loading",
        // pullDownHeight: 40
      },
      windowRef: null,
      searchQuery: "",
      sidebarFilterActive: false,
      displayPublicQuotesPage: false,
      canDisplayContentPrivate: false,
      displayQuotesPage: false,
      backgroundQuotesPage: false,
      displayAksAnalystPage: false,
      displayWeatherPage: false,
      notExpand: true,
      contents: {
        analysis: [],
        quotes: [],
        favorites: [],
      },
      filters: {
        characteristic: [],
        periodicity: [],
        country: [],
        topic: [],
        exclusive: false,
      },
      displayFilters: false,
      commodityId: null,
      reportsData: [],
      totalResults: 0,
      displayNotFountReportData: false,
      reportsDataHighlights: [],
      reportDetail: null,
      selectedFilter: {
        characteristic: [],
        periodicity: [],
        country: [],
        content: [],
        subject: [],
        topic: [],
        users: null,
        reportType: null,
      },
      openMailId: null,
      isReportViewSidebarActive: false,
      showThread: false,
      clickNotClose: true,
      isReportSidebarActive: true,
      settings: {
        maxScrollbarLength: 100,
        minScrollbarLength: 40,
        wheelSpeed: 2,
        swipeEasingFriction: 2,
        swipeEasing: true,
        wheelPropagation: true,
        suppressScrollX: true,
        scrollYMarginOffset: 100,
      },
      relatedNews: {
        free_title: "",
        free_text: "",
        news: [],
      },
      currentPage: 1,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      totalPages: 1,
      displayLoadInBtn: false,
      displayPopupContentFilterMobile: false,
      // changeScrollY: false,
      scrollPullToRefresh: true,
      displayBackToTopBtn: false,
      perfectScrollbarReachEnd: false, // to prevents fires multiple times
      refreshPooling: null,
      previousContent: null,
      dropdownFilterVisible: true,
      expandedFilter: false,
      loadedNewsDetail: false,
      canDisplayHighlight: false,
      isMaximizedDetail: false,
      newsTickerData: [],
      tickerInterval: null,
    };
  },
  watch: {
    "$store.state.systemLogin"(value) {
      // User has logget out: closes the Tmn Window
      if (!value) {
        this.closeTmnWindow();
      }
    },
    "$i18n.locale"(value) {
      // TODO FELIPE
      // userService.updateUser(new URLSearchParams(), {language: value});

      // multi language - when change value request new data from server
      this.loadContentList();
    },
    // searchQuery() {
    //   this.debouncedGetAnswer();
    // },
    // isReportViewSidebarActive(value) {
    //   if (!value) this.showThread = false;
    // },
    windowWidth() {
      this.setSidebarWidth();
    },
    currentCommodity(val) {
      this.closePlaylist();
      this.maximizeDetail(false);
      this.onBackToTop();
      // console.log('changed commodity: ', val);
      // this.changeScrollY = false;
      this.displayPopupContentFilterMobile = false;
      this.loadedNewsDetail = false;
      // this.isReportViewSidebarActive = false;
      if (this.currentContent.isQuotes) {
        this.openQuotesPage(true);
        this.openAskAnalystPage(false);
        this.openWeatherPage(false);
        this.openDetail(null);
        this.reportViewActive(false);
      } else {
        this.openQuotesPage(false);
        this.openAskAnalystPage(false);
        this.openWeatherPage(false);
        this.closeReportViewSidebar();
      }
      // this.reportDetail = null;
      // this.commodityId = this.$route.params.commodity;
      this.searchQuery = this.$route.query.q;
      // this.selectedFilter = {};
      // this.currentContent = AppConstants.INFORMATIVE_FILTER_ALL_OPTION;
      // EventBus.$emit(AppConstants.BUS_EVENT_CLEAR_FILTER, {});

      // this.$store.dispatch("updateCurrentContentToDefault"); // clear current content
      this.$store.dispatch("updateCurrentReportType", { id: null }); // clear current reportType

      if (this.selectedFilter.country) {
        this.selectedFilter.country = [];
      }
      if (this.selectedFilter.topic) {
        this.selectedFilter.topic = [];
      }
      if (this.selectedFilter.content) {
        this.selectedFilter.content = [];
      }
      if (this.selectedFilter.subject) {
        this.selectedFilter.subject = [];
      }
      if (this.selectedFilter.users) {
        this.selectedFilter.users = null;
      }
      this.loadContentList();
      // this.loadReportData();
      // this.loadReportHighlights();
    },
  },
  computed: {
    insetStyle() {
      return getInsetStyle();
    },
    highlightCollapsed() {
      return this.$store.state.highlightCollapsed;
    },
    isWindowDetached() {
      return !!this.$route.query.currentCommodity;
    },
    userProfile() {
      return this.$store.state.AppActiveUser.profile;
    },
    isProfileFree() {
      return this.userProfile == AppConstants.USER_PROFILE.FREE;
    },
    highlightComponent() {
      return this.$refs["highlight-component"];
    },
    canDisplayTicker: {
      get() {
        return this.$store.state.canDisplayTicker;
      },
      set(val) {
        this.$store.dispatch("canDisplayTicker", val);
        this.$forceUpdate();
      },
    },
    viewImportantTickers: {
      get() {
        return this.$store.state.viewImportantTickers;
      },
      set(val) {
        localStorageHelper.updateViewImportantTickers(val);
      },
    },
    viewHighlightsTickers: {
      get() {
        return this.$store.state.viewHighlightsTickers;
      },
      set(val) {
        localStorageHelper.updateViewHighlightsTickers(val);
      },
    },
    tickerViewAtTheTop: {
      get() {
        return this.$store.state.tickerViewAtTheTop;
      },
      set(val) {
        this.$store.dispatch("tickerViewAtTheTop", val);
        this.$forceUpdate();
      },
    },
    // canDisplayTicker() {
    //   return this.$store.state.canDisplayTicker;
    // },
    isTabletResolution() {
      return this.windowWidth > 576 && this.windowWidth < 1024;
    },
    reduceSidebar() {
      return this.$store.state.contentSubmenuReduceSidebar;
    },
    currentReportTypeList() {
      if (this.currentContent.reportType) {
        return this.currentContent.reportType;
      }
      return [];
    },
    refreshActive() {
      return this.$store.state.refreshActive;
    },
    numCardsMosaic() {
      if (this.windowWidth >= 1700) {
        return 2;
      } else if (this.windowWidth >= 1200 && this.windowWidth < 1700) {
        return 3;
      } else if (this.windowWidth >= 800 && this.windowWidth < 1200) {
        return 4;
      } else if (this.windowWidth < 800) {
        return 6;
      }
      return 2;
    },
    verticalNavMenuWidth() {
      // console.log('verticalNavMenuWidth', this.$store.state.verticalNavMenuWidth)
      return this.$store.state.verticalNavMenuWidth;
    },
    currentFilter() {
      return this.$store.state.currentFilter;
    },
    cardViewNumCard() {
      if (this.tinnyScreen || this.smallScreen) {
        return 6;
      }
      return 6;
    },
    tinnyScreen() {
      return generalHelper.tinnyScreen(this.windowWidth);
    },
    tinnysScreen() {
      return generalHelper.tinnysScreen(this.windowWidth);
    },
    smallScreen() {
      return generalHelper.smallScreen(this.windowWidth);
    },
    smallsScreen() {
      return generalHelper.smallsScreen(this.windowWidth);
    },
    mediumScreen() {
      return generalHelper.mediumScreen(this.windowWidth);
    },
    largeScreen() {
      return generalHelper.largeScreen(this.windowWidth);
    },
    bigScreen() {
      return generalHelper.bigScreen(this.windowWidth);
    },
    hugeScreen() {
      return generalHelper.hugeScreen(this.windowWidth);
    },
    paramsNewsID() {
      return this.$route.params.id;
    },
    quotesPublicData() {
      return this.$store.state.quotesPublic;
    },
    contentPrivate() {
      return this.$store.state.contentPrivate;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    contentList() {
      // console.log('[contentList][favorites]', this.contents.favorites);
      return this.contents.favorites
        .concat(this.contents.analysis)
        .concat(this.contents.quotes);
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    currentCommodity() {
      return this.$store.state.currentCommodity;
    },
    currentContent() {
      return this.$store.state.currentContent;
    },
    currentReportType() {
      return this.$store.state.currentReportType;
    },
    lastPublishName() {
      let name = this.$t("USER_SIGNATURE").Publications;
      if (this.currentContent && this.currentContent.id) {
        name = this.currentContent
          ? `${
              this.currentContent[
                `name${getCodeLang(localStorageHelper.getLocale())}`
              ]
            }`
          : this.$t("USER_SIGNATURE").Publications;
      }
      if (!name) {
        name = this.$t("USER_SIGNATURE").Publications;
      }
      // return `Últimas ${name}`;
      // return `${this.$t('USER_SIGNATURE').Latest} ${name}`;
      return name;
    },
    currentContentName() {
      // console.log('[currentContentName] ',this.currentContent);
      if (this.currentContent && this.currentContent.id) {
        return this.currentContent
          ? `${this.currentContent[
              `name${getCodeLang(localStorageHelper.getLocale())}`
            ].toUpperCase()}`
          : "TODOS";
      }
      return this.currentContent
        ? `${this.currentContent.nome.toUpperCase()}${this.reportTypeName}`
        : "TODOS";
    },
    reportTypeName() {
      if (this.currentReportType) {
        return this.currentReportType.id
          ? ` / ${this.currentReportType.name.toUpperCase()}`
          : "";
      }
      return "";
    },
    isCalendarView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.CALENDAR
      );
    },
    isListView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
    },
    isListViewDetailed() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    isCardView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.CARDVIEW
      );
    },
    isMosaicView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.MOSAIC
      );
    },
    isConsulting() {
      if (this.currentContent) {
        if (
          this.currentContent.id == CONTENT.CONSULTING ||
          this.currentContent.id == CONTENT.CONSULTING_SAFRAS_TV ||
          this.currentContent.id == CONTENT.CONSULTING_SAFRAS_PODCAST ||
          this.currentContent.id == CONTENT.CONSULTING_COURSES ||
          this.currentContent.id == CONTENT.CONSULTING_SPEECHES ||
          this.currentContent.id == CONTENT.CONSULTING_EXCHANGE
        ) {
          return true;
        }
      }
      return false;
    },
    isWhatsItContent() {
      if (this.currentContent && this.currentContent.id == CONTENT.WHAT_IS_IT) {
        return true;
      }
      return false;
    },
    isCalendarContent() {
      if (this.currentContent && this.currentContent.id == CONTENT.CALENDAR) {
        return true;
      }
      return false;
    },
    isNews() {
      if (this.currentContent && this.currentContent.id == CONTENT.NEWS) {
        return true;
      }
      return false;
    },
    isWeather() {
      if (this.currentContent && this.currentContent.id == CONTENT.WEATHER) {
        return true;
      }
      return false;
    },
    isQuotes() {
      return tmnHelper.isTmnContent(this.currentContent);
    },
    isImageHeaderAllCommotitiesAndMobile() {
      return !this.isDesktop && this.currentCommodity.id == 0;
    },
    informativeTextFilter() {
      return this.$t("REPORT_FILTER").Informative_Title;
    },
    hasHighlights() {
      // can't display highlights when content selected is consulting, news, weather or quotes.
      return this.reportsDataHighlights.length > 0;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    commodityTitle() {
      // if (!this.isAuthenticated) {
      //   return 'teste'
      // }
      if (this.currentCommodity.id == 0) {
        return this.$t("REPORT").All_Commodities;
      }
      if (this.AppActiveUser.rights) {
        const actualCommodity = this.AppActiveUser.rights.find(
          (el) => el.id == this.currentCommodity.id
        );
        if (actualCommodity) {
          return actualCommodity[
            `label${getCodeLang(localStorageHelper.getLocale())}`
          ];
        }
      }

      return "";
    },
    commodityTitlePt() {
      if (this.currentCommodity.id == 0) {
        return "Todas Commodities";
      }

      const actualCommodity = this.AppActiveUser.rights.find(
        (el) => el.id == this.currentCommodity.id
      );
      if (actualCommodity) {
        return actualCommodity.nome;
      }

      return "";
    },
    currentCommodityNameTitle() {
      const title = this.commodityTitle;
      if (!title) {
        return this.currentCommodity.name;
      }
      return title;
    },
    currentCommodityName() {
      const actualCommodity = this.AppActiveUser.rights.find(
        (el) => el.id == this.currentCommodity.id
      );
      if (actualCommodity) {
        return actualCommodity[
          `label${getCodeLang(localStorageHelper.getLocale())}`
        ];
      }
      return "";
    },
    showLoadMorePage() {
      return this.totalPages > 1 && this.currentPage !== this.totalPages;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
  },
  methods: {
    changeCollapseHighlights() {
      const val = !this.highlightCollapsed;
      const form = {
        highlightCollapsed: val,
      };
      localStorageHelper.updateHighlightCollapsed(val);
      if (this.isAuthenticated) {
        layoutService.saveLayout(form, new URLSearchParams());
      }
    },
    selectFirstQuotesContent() {
      if (this.$refs["informative-sidebar"]) {
        this.$refs["informative-sidebar"].selectFirstQuotesContent();
      }
    },
    updateHighlightSlides() {
      if (!this.canDisplayHighlight) return;
      try {
        // this.highlightComponent.updateSlides();
        this.$refs["highlight-component"].updateSlides();
      } catch (error) {}
    },
    closePlaylist() {
      EventBus.$emit(AppConstants.BUS_EVENT_CLOSE_PLAYLIST);
    },
    changeDisplayTicker() {
      this.canDisplayTicker = !this.canDisplayTicker;
    },
    tickerFilterImportantSelected() {
      this.viewImportantTickers = !this.viewImportantTickers;
      this.loadReportTickers();
    },
    tickerFilterHighlightsSelected() {
      this.viewHighlightsTickers = !this.viewHighlightsTickers;
      this.loadReportTickers();
    },
    tickerViewOnPageTop() {
      this.tickerViewAtTheTop = !this.tickerViewAtTheTop;
    },
    saveScheduleNews(dataNews) {
      this.$store.dispatch("insertScheduleData", dataNews);
      messagesNotifyHelper.successNotify(
        "Calendário",
        "Noticia salvo com sucesso"
      );
    },
    updateDataFromCalendar(dataCalendar) {},
    testCalendarApi() {
      console.log(
        "[testCalendarApi] ",
        this.$refs["calendarComponent"].currentCalendar.getApi()
      );
    },
    changeMobileContentListTabIndex(val) {
      this.mobileContentListTabIndex = val;
    },
    changeDisplayPopupContentFilterMobile(val) {
      this.displayPopupContentFilterMobile = val;
    },
    updateReduceSidebar(val) {
      this.$store.dispatch("updateContentSubmenuReduceSidebar", val);
    },
    canFocusSearch() {
      if (!this.isAuthenticated) {
        this.displayExclusiveContent();
        return;
      }
    },
    isCurrentReportTypeSelected(item) {
      if (this.currentReportType) {
        return this.currentReportType.id == item.id;
      }
      return false;
    },
    selectReportType(item) {
      this.$store.dispatch("updateCurrentReportType", item);
      this.mobileContentListTabIndex = 0;
      this.displayPopupContentFilterMobile = false;
      this.reloadDataWithFilter({ selectedFilter: this.selectedFilter });
    },
    displayFilterBadgeSelected() {
      let badge = 0;
      Object.keys(this.selectedFilter).forEach((key) => {
        if (key != "reportType") {
          if (
            key == "characteristic" ||
            key == "periodicity" ||
            key == "country" ||
            key == "topic" ||
            key == "content" ||
            key == "subject"
          ) {
            badge += this.selectedFilter[key].length;
          } else if (this.selectedFilter[key]) {
            badge++;
          }
        }
      });
      return badge > 0;
    },
    updateRefreshActive(param) {
      this.$store.dispatch("updateRefreshActive", param);
      this.$forceUpdate();
    },
    maximizeDetail(val) {
      this.isMaximizedDetail = val;
    },
    onRefresh() {
      this.loadReportData();
      this.loadReportHighlights();
      // this.loadReportTickers();
    },
    onClose() {
      this.displayPopupContentFilterMobile = false;
    },
    openPlaylist() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_AUTHOR_DETAIL, null);
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, true);
    },
    openSchedule() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_AUTHOR_DETAIL, null);
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, true);
      EventBus.$emit("open-calendar");
    },
    openImageMobile(image) {
      if (image) {
        console.log("[informative][openImageMobile]", JSON.stringify(image));
        this.downloadFileMobile(
          image.original_filename,
          image.extension,
          image.image_path,
          ""
        );
      }
      // if (checkDeviceTypeHelper.getUrlLogin()) {
      // }
    },
    onScroll(e) {
      if (e.target.scrollTop != 0) {
        this.scrollPullToRefresh = false;
      } else {
        this.scrollPullToRefresh = true;
      }
      if (e.target.scrollTop < 300) {
        this.displayBackToTopBtn = false;
      } else {
        this.displayBackToTopBtn = true;
      }

      if (this.isAuthenticated) {
        // console.log('[onScroll-offsetHeight] ',e.target.offsetHeight)
        // console.log('[onScroll-clientHeight] ',e.target.clientHeight)
        // console.log('[onScroll-scrollHeight] ',e.target.scrollHeight)
        // console.log('[onScroll-scrollTop] ',e.target.scrollTop)

        // if (this.$refs['informative-scroll'].scrollTop  > 500) {
        //   this.$refs['informative-scroll'].scrollTop = 0
        // }
        // console.log('[onScroll-sum-position] ',e.target.offsetHeight + e.target.scrollTop)
        // console.log('[onScroll-bottom] ',e.target.offsetHeight + e.target.scrollTop >= (e.target.scrollHeight - 100))
        if (
          e.target.offsetHeight + e.target.scrollTop >=
            e.target.scrollHeight - 100 &&
          !this.isCalendarView
        ) {
          console.log("scroll reach to end");
          this.scrollHandleToEnd();
        }
      }
      // console.log('[informative-scroll]',  this.$refs['informative-scroll']);
      // if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
      //   alert("you're at the bottom of the page");
      // }

      // var currentScrollPosition = e.srcElement.scrollTop;
      // if (currentScrollPosition > this.scrollPosition) {
      //     console.log("Scrolling down");
      // }
      // this.scrollPosition = currentScrollPosition;

      // { target: { scrollTop, clientHeight, scrollHeight }}
      // if (scrollTop + clientHeight >= scrollHeight) {
      //   console.log('scroll reach to end');
      //   this.scrollHandleToEnd();
      // }
    },
    displayExclusiveContent() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP);
    },
    openRegister() {
      this.closeFilter();
      setTimeout(() => {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_REGISTER);
      }, 200);
    },
    openLogin() {
      this.closeFilter();
      setTimeout(() => {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_LOGIN);
      }, 200);
    },
    onFilterFromTag(item) {
      if (this.isAuthenticated) {
        console.log("[onFilterFromTag]", item);
        if (!item.value.id && item.value.code) item.value.id = item.value.code;
        const filter = this.selectedFilter;
        switch (item.field) {
          case "subject":
            if (!filter.subject) filter.subject = [];
            filter.subject.push(item.value);
            break;
          case "content":
            if (!filter.content) filter.content = [];
            filter.content.push(item.value);
            break;
          case "characteristic":
            if (!filter.characteristic) filter.characteristic = [];
            filter.characteristic.push(item.value);
            break;
          case "periodicity":
            if (!filter.periodicity) filter.periodicity = [];
            filter.periodicity.push(item.value);
            break;
          case "country":
            if (!filter.country) filter.country = [];
            filter.country.push(item.value);
            break;
          case "topic":
            if (!filter.topic) filter.topic = [];
            filter.topic.push(item.value);
            break;
          case "users":
            filter.users = item.value;
            break;
          case "searchQuery":
            this.searchQuery = item.value;
            filter.searchQuery = item.value;
            break;
          default:
            filter[item.field] = item.value;
        }
        // this.$store.dispatch('updateCurrentFilter', filter);
        this.reloadDataWithFilter(filter);
        // this.selectedFilter.subjectList.push(item.value);
        // this.$refs['filter-page'].onFilterFromTag(item);
      } else {
        this.displayExclusiveContent();
      }
    },
    openAuthorDetail(item) {
      // if (!this.isDesktop) {
      //   this.reportViewActive(false);
      // }
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_AUTHOR_DETAIL, item);
    },
    openUserRightsModal(item) {
      // console.log('openUserRightsModal');
      messageDialogHelper.displayUserRightsMessage(item.nome, () => {
        let text = this.$t("HELP_ATTENDANCE").NoRights_Text_Content;
        text = text.replace("%", item.nome);
        text = text.replace("#", this.currentCommodityName);
        this.displayPopupContentFilterMobile = false;
        EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, text);
      });
    },
    isItemSelected(data) {
      if (!this.reportDetail) return false;
      if (!this.isAuthenticated) {
        return this.reportDetail.uuid == data.uuid;
      }
      return this.reportDetail._id == data._id;
    },
    onDownloadFile(detail) {
      console.log("[onDownloadFile]");
      const url = detail.document.image_path;
      if (detail.document.extension != "pdf" || !this.isAuthenticated) {
        if (this.isDesktop || !checkDeviceTypeHelper.isNativeApp()) {
          const params = new URLSearchParams();
          params.append("download", true);
          reportService
            .downloadReportFile(detail.document.image_path, params)
            .then((res) => {
              this.downloadFileDesktop(
                detail,
                window.URL.createObjectURL(new Blob([res.data]))
              );
            })
            .catch((err) => {
              console.log(err);
              this.$refs["informative-view"].removeDownloadSpinner();
            });
        } else {
          // MOBILE
          this.$refs["informative-view"].removeDownloadSpinner();
          this.downloadFileMobile(
            detail.document.original_filename,
            detail.document.extension,
            url,
            ""
          );
        }
        return;
      }
      if (detail.document.extension == "pdf") {
        if (this.isAuthenticated) {
          const params = new URLSearchParams();
          params.append("download", true);
          params.append("id", detail._id);
          reportService
            .readDocumentFile(detail._id, params)
            .then((response) => {
              const bytes = this.CryptoJS.AES.decrypt(
                response.data,
                AppConstants.PDF_PWD
              );
              const pdfPlain = bytes.toString(this.CryptoJS.enc.Utf8);
              const pdfData = Buffer.from(pdfPlain, "base64");
              const url = window.URL.createObjectURL(new Blob([pdfData]));

              if (this.isDesktop || !checkDeviceTypeHelper.isNativeApp()) {
                this.downloadFileDesktop(detail, url);
              } else {
                this.downloadFileMobile(
                  detail.document.original_filename,
                  detail.document.extension,
                  url,
                  new Blob([pdfData])
                );
              }
            })
            .catch((error) => {
              console.log(error);
              this.$refs["informative-view"].removeDownloadSpinner();
              // this.$vs.loading.close("#download-content > .con-vs-loading");
            });
        }
      }
    },
    downloadFileDesktop(detail, url) {
      this.$refs["informative-view"].removeDownloadSpinner();
      // this.$vs.loading.close("#download-content > .con-vs-loading");
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", detail.document.original_filename);
      // link.setAttribute("download", `${this.getSubjectTranslateFieldName(detail.subjects)}.${detail.document.extension}`);
      link.setAttribute("id", "link-download");
      document.body.appendChild(link);
      link.click();
      document.getElementById("link-download").remove();
      console.log("[desktop] downloading:", detail.document.original_filename);
      // console.log(`${this.getSubjectTranslateFieldName(detail.subjects)}.${detail.document.extension}`);
    },
    getMimeType(extension) {
      if (extension === "pdf") {
        return "application/pdf";
      }

      if (extension === "doc") {
        return "application/msword";
      }

      if (extension === "docx") {
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      }

      if (extension === "xls") {
        return "application/vnd.ms-excel";
      }

      if (extension === "xlsx") {
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      }

      if (extension === "xlsm") {
        return "application/vnd.ms-excel.sheet.macroEnabled.12";
      }

      if (extension === "xlsm") {
        return "application/vnd.ms-excel.sheet.macroEnabled.12";
      }

      // IMAGES
      if (extension === "png") {
        return "image/png";
      }

      if (extension === "jpg" || extension === "jpeg") {
        return "image/jpeg";
      }

      return "";
    },
    downloadFileMobile(original_filename, extension, uri, data) {
      if (checkDeviceTypeHelper.isReactApp()) {
        // download into app react native
        console.log(
          `[mobile] downloading original_filename: ${original_filename}`
        );
        const mimeType = this.getMimeType(extension);
        if ((!mimeType && !data) || mimeType.includes("image")) {
          this.$refs["informative-view"].removeDownloadSpinner();
          console.log(`[mobile][openImage][${mimeType}] url: ${uri}`);
          biometryHelper.openImage(uri, mimeType);
        } else {
          console.log(`[mobile][openDocument][${mimeType}] with data`);
          // biometryHelper.openImage(data, mimeType);
          this.$refs["informative-view"].removeDownloadSpinner();
          if (extension.includes("pdf") && data) {
            // biometryHelper.openDocument('', original_filename, extension, mimeType, data);
            this.downloadFileReactApp(uri, original_filename);
          } else {
            // office view
            let officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${uri}`;
            // biometryHelper.openDocument(uri, original_filename, extension, mimeType, '');
            biometryHelper.openDocument(
              officeUrl,
              original_filename,
              extension,
              mimeType,
              ""
            );
          }
          // if (!data) {
          //   // create blob when data is empty
          //   const params = new URLSearchParams();
          //   params.append('download', true);
          //   reportService.downloadReportFile(uri, params)
          //     .then(res => {
          //       this.$refs['informative-view'].removeDownloadSpinner();
          //       console.log(`[mobile] data received from url, creating new blob`);
          //       this.downloadFileReactApp(window.URL.createObjectURL(new Blob([res.data])), original_filename);
          //     }).catch(err => {
          //       this.$refs['informative-view'].removeDownloadSpinner();
          //       console.log(err);
          //     });
          // } else {
          //   this.downloadFileReactApp(uri, original_filename);
          //   this.$refs['informative-view'].removeDownloadSpinner();
          // }
        }

        // if (data) {
        //   this.$refs['informative-view'].removeDownloadSpinner();
        //   biometryHelper.openImage(data);
        // } else {
        //   const params = new URLSearchParams();
        //   params.append('download', true);
        //   console.log(`[mobile] get blob from url: ${uri}`);
        //   reportService.downloadReportFile(uri, params)
        //     .then(res => {
        //       this.$refs['informative-view'].removeDownloadSpinner();
        //       console.log(`[mobile] data received from url, creating new blob from `, res.data);
        //       biometryHelper.openImage(new Blob([res.data]));
        //     }).catch(err => {
        //       this.$refs['informative-view'].removeDownloadSpinner();
        //       console.log(err);
        //     });
        // }
      } else {
        // download production
        this.$refs["informative-view"].removeDownloadSpinner();
        this.$forceUpdate();
        this.$nextTick(() => {
          setTimeout(() => {
            try {
              const mimeType = this.getMimeType(extension);

              if (data && extension.toLowerCase() === "pdf") {
                const folderpath = cordova.file.dataDirectory;

                window.resolveLocalFileSystemURL(folderpath, function (dir) {
                  dir.getFile(
                    original_filename,
                    { create: true },
                    function (file) {
                      file.createWriter(
                        function (fileWriter) {
                          fileWriter.write(data);
                          cordova.plugins.fileOpener2.open(
                            folderpath + original_filename,
                            mimeType
                          );
                        },
                        function () {
                          console.log(
                            "Unable to save file in path " + folderpath
                          );
                          // this.$vs.loading.close("#download-content > .con-vs-loading");
                        }
                      );
                    }
                  );
                });
              } else {
                this.$refs["informative-view"].removeDownloadSpinner();
                const fileTransfer = new FileTransfer();

                const fileURL = cordova.file.dataDirectory + original_filename;

                // fileTransfer.onprogress = function(progressEvent) {
                //     if (progressEvent.lengthComputable) {
                //       console.log('[download][progress][lengthComputable]', progressEvent.loaded / progressEvent.total);
                //       // loadingStatus.setPercentage(progressEvent.loaded / progressEvent.total);
                //     } else {
                //       // loadingStatus.increment();
                //       console.log('[download][progress][lengthComputable] increment+');
                //     }
                // };

                fileTransfer.download(
                  uri,
                  fileURL,
                  function (entry) {
                    cordova.plugins.fileOpener2.open(fileURL, mimeType, {
                      error: function (e) {
                        console.log(
                          "Error status: " +
                            e.status +
                            " - Error message: " +
                            e.message
                        );
                        // this.$vs.loading.close("#download-content > .con-vs-loading");
                        this.$refs["informative-view"].removeDownloadSpinner();
                      },
                      success: function () {
                        console.log("file opened successfully");
                        // this.$vs.loading.close("#download-content > .con-vs-loading");
                        this.$refs["informative-view"].removeDownloadSpinner();
                      },
                    });
                  },
                  function (error) {
                    console.log("download error source " + error.source);
                    console.log("download error target " + error.target);
                    console.log("download error code" + error.code);
                    this.$refs["informative-view"].removeDownloadSpinner();
                    // this.$vs.loading.close("#download-content > .con-vs-loading");
                  },
                  false,
                  {}
                );
              }
            } catch (e) {
              console.log("Erro ao fazer download");
              // this.$vs.loading.close("#download-content > .con-vs-loading");
              this.$refs["informative-view"].removeDownloadSpinner();
              messagesNotifyHelper.errorNotify(
                this.$t("GENERAL").Error,
                this.$t("GENERAL").Error_Download_File
              );
            }
          }, 500);
        });
      }
    },
    downloadFileReactApp(url, original_filename) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", original_filename);
      link.setAttribute("id", "link-download");
      document.body.appendChild(link);
      link.click();
      document.getElementById("link-download").remove();
    },
    getSubjectTranslateFieldName(subjects) {
      if (this.currentCommodity.id) {
        const sub = subjects.find(
          (item) => item.code == this.currentCommodity.id
        );
        if (sub) {
          const name = sub[`label${this.$i18n.locale}`];
          if (name) {
            return name;
          }
          return sub[`name${this.$i18n.locale}`];
        }
      }
      const name = subjects[0][`label${this.$i18n.locale}`];
      if (name) {
        return name;
      }
      return subjects[0][`name${this.$i18n.locale}`];
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(
        subjects,
        this.currentCommodity
      );
    },
    changeDropdownVisbile(value) {
      this.dropdownFilterVisible = value;
    },
    openViewByScreenSize(data) {
      if (
        this.isDesktop &&
        !this.displayQuotesPage &&
        !this.isWhatsItContent &&
        (this.hugeScreen ||
          this.bigScreen ||
          this.largeScreen ||
          this.mediumScreen)
      ) {
        // if (this.isDesktop && (this.bigScreen || this.largeScreen)) {
        this.openDetail(data);
      }
    },
    displayViewByScreenSize() {
      // console.log('[this.displayQuotesPage]',this.displayQuotesPage);
      if (
        this.isDesktop &&
        !this.displayQuotesPage &&
        !this.displayAksAnalystPage &&
        !this.displayWeatherPage &&
        !this.isWhatsItContent &&
        !this.isMosaicView &&
        !this.isCalendarView &&
        (this.hugeScreen ||
          this.bigScreen ||
          this.largeScreen ||
          this.mediumScreen ||
          this.smallsScreen)
      ) {
        this.reportViewActive(true);
      } else {
        this.reportViewActive(false);
      }
      this.updateHighlightSlides();
    },
    changeToCalendarView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.CALENDAR
      );
      // this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.CALENDAR);
      if (this.isDesktop) {
        this.reportViewActive(false);
      }
    },
    listView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
      this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.LISTVIEW);
      this.displayViewByScreenSize();
      if (this.isDesktop) {
        this.checkOpenDetailFirstAccess();
      }
    },
    listViewDetailed() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
      this.saveReportViewStyle(
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
      this.updateHighlightSlides();
      this.displayViewByScreenSize();
      if (this.isDesktop) {
        this.checkOpenDetailFirstAccess();
      }
    },
    cardView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.CARDVIEW
      );
      this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.CARDVIEW);
      this.updateHighlightSlides();
      this.displayViewByScreenSize();
      if (this.isDesktop) {
        this.checkOpenDetailFirstAccess();
      }
    },
    mosaicView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.MOSAIC
      );
      this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.MOSAIC);
      if (this.isDesktop) {
        this.reportViewActive(false);
      }
      this.updateHighlightSlides();
    },
    checkOpenDetailFirstAccess() {
      if (!this.reportDetail) {
        this.openDetail(this.reportsData[0]);
      }
    },
    saveReportViewStyle(val) {
      localStorageHelper.updateReportViewStyle(val);

      const form = {
        viewstyle: val,
      };
      if (this.isAuthenticated) {
        layoutService.saveLayout(form, new URLSearchParams());
      }
    },
    playMultimedia(detail) {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_DRAGGABLE_MULTIMEDIA, {
        reportDetail: detail.data,
        isTextSpeech: detail.isTextSpeech,
      });
    },
    // refreshTicker() {
    //   if (this.isAuthenticated && this.canDisplayTicker) {
    //     const params = this.buildTickerSearchParams();
    //     // if (this.newsTickerData.length > 0) {
    //     //   params.append("lastPublishDate", this.newsTickerData[0].dt_publish);
    //     // }

    //     reportService
    //       .getNewsTicker(params)
    //       .then(response => {
    //         response.data.forEach(item => {
    //           if (this.newsTickerData.findIndex(r => r._id == item._id) < 0) {
    //             this.newsTickerData.unshift(item);
    //           }
    //         })
    //       })
    //       .catch(error => console.log(error));
    //   }
    // },
    refreshReports() {
      if (this.refreshActive) return;
      this.updateRefreshActive(true);
      if (this.currentContent.id) {
        if (
          this.currentContent.id == CONTENT.ASK_ANALYST ||
          this.currentContent.id == CONTENT.PHYSICAL_MARKET ||
          this.currentContent.id == CONTENT.FUTURE_MARKET ||
          this.currentContent.id == CONTENT.INDICATIVE_MARKET ||
          this.currentContent.id == CONTENT.EXCHANGE_MARKET ||
          this.currentContent.id == CONTENT.ACTIVE_MARKET ||
          this.currentContent.id == CONTENT.HEDGE_WHATS ||
          this.currentContent.id == CONTENT.WHAT_IS_IT
        )
          return;
      }
      const params = this.buildSearchParams();
      const highlightsParams = new URLSearchParams();
      const dtNow = new Date();
      let highlightLastPublishDate = dtNow.toISOString();

      if (this.reportsData.length > 0) {
        if (
          this.currentContent.id == CONTENT.INFORMATIVE ||
          this.currentContent.id == CONTENT.STATISTIC ||
          this.currentContent.id == CONTENT.EXPORTS
        ) {
          params.append("lastReportDate", this.reportsData[0].dt_report);
        } else {
          params.append("lastPublishDate", this.reportsData[0].dt_publish);
        }
      }

      if (this.reportsDataHighlights.length > 0) {
        if (
          this.currentContent.id == CONTENT.INFORMATIVE ||
          this.currentContent.id == CONTENT.STATISTIC ||
          this.currentContent.id == CONTENT.EXPORTS
        ) {
          highlightsParams.append(
            "lastReportDate",
            this.reportsDataHighlights[0].dt_report
          );
          highlightLastPublishDate = "";
        } else {
          highlightLastPublishDate = this.reportsDataHighlights[0].dt_publish;
          // highlightsParams.append("lastPublishDate", this.reportsDataHighlights[0].dt_publish)
        }
      }
      if (highlightLastPublishDate) {
        highlightsParams.append("lastPublishDate", highlightLastPublishDate);
      }
      highlightsParams.append("page", "1");
      highlightsParams.append(
        "limit",
        AppConstants.HIGHLIGHTS_DEFAULT_CAROUSEL_LIMIT
      );
      highlightsParams.append("highlights", true);

      highlightsParams.append("commodity", this.currentCommodity.id);
      highlightsParams.append("originCode", this.currentCommodity.originCode);
      if (this.currentContent && this.currentContent.id) {
        highlightsParams.append("content", this.currentContent.id);
      }

      Promise.all([
        reportService.getAllReportsByCommodity(params),
        reportService.getAllReportsByCommodity(highlightsParams),
      ])
        .then((response) => {
          response[0].data.forEach((item) => {
            if (this.reportsData.findIndex((r) => r._id == item._id) < 0) {
              this.reportsData.unshift(item);
            }
          });
          // HIGHLIGHTS
          response[1].data.forEach((item) => {
            if (
              this.reportsDataHighlights.findIndex((r) => r._id == item._id) < 0
            ) {
              this.reportsDataHighlights.unshift(item);
            }
          });
          this.updateHighlightSlides();
          this.canDisplayHighlight = true;

          // Timeout para mostrar animacao
          setTimeout(() => this.updateRefreshActive(false), 900);
        })
        .catch((error) => {
          this.updateRefreshActive(false);
          console.log(error);
        });
    },
    onBackToTop() {
      // const scroll = document.querySelector("#informative-scroll");
      // scroll.scrollTop = 0;
      if (this.$refs["informative-scroll"]) {
        this.$refs["informative-scroll"].scrollTop = 0;
        this.displayBackToTopBtn = false;
      }
    },
    scrollHandle(evt) {
      // console.log('[scrollHandle]', evt.target.scrollTop);
      if (this.isDesktop) {
        if (evt.target.scrollTop < 300) {
          this.displayBackToTopBtn = false;
        } else {
          this.displayBackToTopBtn = true;
        }
        // if (evt.target.scrollTop > 60) {
        //   // this.changeScrollY = true;
        // }
        // if (evt.target.scrollTop < 60) {
        //   // this.changeScrollY = false;
        // }
      } else {
        if (evt.target.scrollTop < 300) {
          this.displayBackToTopBtn = false;
        } else {
          this.displayBackToTopBtn = true;
        }
      }
      // console.log(evt.target.scrollTop);
    },
    scrollHandleToEnd(evt) {
      console.log(
        "[scrollHandleToEnd][perfectScrollbarReachEnd]",
        this.perfectScrollbarReachEnd
      );
      console.log(
        "[scrollHandleToEnd][showLoadMorePage]",
        this.showLoadMorePage
      );
      if (this.perfectScrollbarReachEnd) {
        return;
      }
      if (!this.perfectScrollbarReachEnd && this.showLoadMorePage) {
        this.perfectScrollbarReachEnd = true;
        // console.log(evt);
        this.loadMorePage();
      }
    },
    getWidthHeightPopup() {
      return { width: screen.width - 300, height: screen.height - 200 };
    },
    getTopLeftPopup(width, height) {
      const left = screen.width / 2 - width / 2;
      const top = screen.height / 2 - height / 2;

      return { top, left };
    },
    getPopupFeatures(top, left, width, height) {
      return `width=${width},height=${height},left=${left},top=${top}`;
    },
    openQuotesPagePopup(content) {
      // Only 1 window is permitted
      if (this.windowRef) {
        this.closeTmnWindow();
      }
      // let routeData = this.$router.resolve({name: 'quotes', query: {currentCommodity: this.commodityTitlePt, currentContent: content.nome}});
      // let routeData = this.$router.resolve({name: 'quotes', query: {currentCommodity: this.currentCommodity.id, currentContent: content.id}});
      let routeData = this.$router.resolve({
        name: "informative",
        params: { commodity: this.currentCommodity.id },
        query: {
          currentCommodity: this.currentCommodity.id,
          currentContent: content.id,
        },
      });

      const { width, height } = this.getWidthHeightPopup();
      const { top, left } = this.getTopLeftPopup(width, height);
      this.windowRef = window.open(
        routeData.href,
        "wdma_window",
        this.getPopupFeatures(top, left, width, height)
      );

      this.windowRef.addEventListener("beforeunload", this.closeTmnWindow);
      this.$store.dispatch("updateCurrentContentToDefault");
      this.loadContentList();

      this.backgroundQuotesPage = false;
    },
    updateBackgroundQuotesPageVisibility() {
      console.log("[updateBackgroundQuotesPageVisibility]");
      if (!this.AppActiveUser || this.$store.state.onLogin) {
        return;
      }
      if (
        this.AppActiveUser.hasQuotesRights &&
        !localStorageHelper.getS4Login()
      ) {
        // console.log('[updateBackgroundQuotesPageVisibility]', true)
        this.backgroundQuotesPage = true;
      }
    },
    closeTmnWindow() {
      if (this.windowRef) {
        this.windowRef.close();
        this.windowRef = null;
        this.selectFirstQuotesContent();
      }

      this.updateBackgroundQuotesPageVisibility();
    },
    openQuotesContent() {
      // TODO - open first quotes content
    },
    detachSDK() {
      this.openQuotesPage(false);
      this.openQuotesPagePopup(this.currentContent);
    },
    openQuotesPage(value) {
      // console.log('[openQuotesPage]', this.currentContent);
      // this.canDisplayContentPrivate = false;
      if (this.isAuthenticated) {
        // this.$store.dispatch("updateSubscribeToolsVisibility", !value);

        if (value) {
          this.closeTmnWindow();
          // this.toggleReduceSidebar(true);
        }
        this.displayQuotesPage = value;
        // if (!this.currentContent.quotesDisplayDetail)  {
        //   this.canDisplayContentPrivate = true;
        // }
      }

      if (value) {
        // this.closeReportViewSidebar();
        this.reportViewActive(false);
      } else if (
        this.isDesktop &&
        !this.displayAksAnalystPage &&
        !this.displayWeatherPage &&
        !this.isMosaicView &&
        !this.isCalendarView
      ) {
        this.displayViewByScreenSize();
      }
      if (this.isWindowDetached) {
        this.updateReduceSidebar(true);
      }
    },
    openAskAnalystPage(value) {
      this.displayAksAnalystPage = value;
      this.$forceUpdate();
      if (value) {
        this.reportViewActive(false);
      } else if (
        this.isDesktop &&
        !this.displayQuotesPage &&
        !this.isMosaicView &&
        !this.isCalendarView
      ) {
        this.displayViewByScreenSize();
      }
    },
    closeAskAnalist() {
      this.displayAksAnalystPage = false;
      this.displayViewByScreenSize();
    },
    openWeatherPage(value) {
      this.displayWeatherPage = value;
      this.$forceUpdate();
      if (value) {
        this.openDetail(null, false, true);
        // this.reportViewActive(false);
      } else if (
        this.isDesktop &&
        !this.displayQuotesPage &&
        !this.isMosaicView &&
        !this.isCalendarView
      ) {
        this.displayViewByScreenSize();
      }
    },
    closeWeatherPage() {
      this.displayWeatherPage = false;
      this.displayViewByScreenSize();
    },
    onBackAnalystPage(content) {
      if (content) {
        this.$store.dispatch("updateCurrentContent", content);
        this.updateHeaderMobileCurrentContent();
      }
      this.openAskAnalystPage(false);
      this.reportViewActive(false);
      this.displayViewByScreenSize();
    },
    toggleReduceSidebar(value) {
      this.updateReduceSidebar(value);
      // this.$refs['highlight-component'].updateSlides();
      EventBus.$emit(AppConstants.BUS_EVENT_UPDATE_HIGHLIGHTS);
      localStorageHelper.setSidebarInformative(value);
    },
    closeReportViewSidebar(data = null) {
      this.reportViewActive(false);
      // this.isReportViewSidebarActive = false;
      // this.reportViewActive(false);

      if (data) {
        if (
          data.currentMediaData.youtubePlayed ||
          data.currentMediaData.audioPlayed
        ) {
          // console.log('closeReportViewSidebar ->>', data);
          EventBus.$emit(
            AppConstants.BUS_EVENT_OPEN_DRAGGABLE_MULTIMEDIA,
            data
          );
          // this.playMultimedia();
        }
      }
    },
    reportViewActive(value) {
      this.isReportViewSidebarActive = value;
    },
    clearSearchQuery() {
      this.searchQuery = "";
      this.searchAll();
    },
    searchAll() {
      if (!this.isAuthenticated) return;
      if (this.isCalendarContent && this.isCalendarView) {
        // console.log(this.$refs['calendarComponent'].searchQuery);
        this.$refs["calendarComponent"].reloadDataEvents(this.searchQuery);
        // console.log(this.$refs['calendarComponent'].searchQuery);
        // this.testCalendarApi();
        // console.log(this.$refs['calendarComponent'].currentCalendar);
        // this.$refs['calendarComponent'].currentCalendar.refetch();
        // this.$refs['calendarComponent'].currentCalendar.getApi().refetchEvents();
        // eventSource.refetch
        return;
      }
      // Id 0 - To search all
      this.loadReportData();
      // this.loadReportHighlights();
      // this.loadContentList();

      this.$router.push({ query: { q: this.searchQuery } });
      // this.$router.push({path: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/0` ,query: {q: this.searchQuery}});
    },
    buildTickerSearchParams() {
      const params = new URLSearchParams();
      params.append("page", "1");
      params.append("limit", AppConstants.TICKER_DEFAULT_LIMIT);
      params.append("commodity", 0);
      params.append("isTicker", true);
      params.append("highlights", true);
      params.append("important", true);
      // if (this.viewHighlightsTickers) {
      //   params.append("highlights", this.viewHighlightsTickers);
      // }
      // if (this.viewImportantTickers) {
      //   params.append("important", this.viewImportantTickers);
      // }

      // if (!this.viewHighlightsTickers && !this.viewImportantTickers) {
      //   params.append("highlights", this.viewHighlightsTickers);
      //   params.append("important", this.viewImportantTickers);
      // }
      return params;
    },
    buildSearchParams() {
      const params = new URLSearchParams();
      params.append("page", this.currentPage);
      params.append("limit", this.limit);
      // params.append("includeFlashes", true);

      params.append("commodity", this.currentCommodity.id);
      params.append("originCode", this.currentCommodity.originCode);

      if (this.isCalendarContent) {
        params.append("calendar", true);
      }

      if (this.isDesktop && this.searchQuery) {
        params.append("searchQuery", this.searchQuery);
      }
      if (!this.isDesktop && this.selectedFilter.searchQuery) {
        params.append("searchQuery", this.selectedFilter.searchQuery);
      }

      if (this.currentContent) {
        if (this.currentContent.id) {
          params.append("content", this.currentContent.id);
        }
        if (this.currentContent.searchOriginCode) {
          params.append(
            "searchOriginCode",
            this.currentContent.searchOriginCode
          );
        }
        if (this.currentContent.searchSubjectId) {
          params.append("searchSubjectId", this.currentContent.searchSubjectId);
        }
      }

      if (this.currentReportType && this.currentReportType.id) {
        params.append("reporttype", this.currentReportType.id);
      }

      if (this.selectedFilter.characteristic) {
        if (this.selectedFilter.characteristic.length > 0) {
          params.append(
            "characteristic",
            this.selectedFilter.characteristic.map((item) => item.id).join(",")
          );
        }
      }

      if (this.selectedFilter.periodicity) {
        if (this.selectedFilter.periodicity.length > 0) {
          params.append(
            "periodicity",
            this.selectedFilter.periodicity.map((item) => item.id).join(",")
          );
        }
      }

      if (this.selectedFilter.country) {
        if (this.selectedFilter.country.length > 0) {
          params.append(
            "country",
            this.selectedFilter.country.map((item) => item.id).join(",")
          );
        }
      }
      if (this.selectedFilter.topic) {
        if (this.selectedFilter.topic.length > 0) {
          params.append(
            "topic",
            this.selectedFilter.topic.map((item) => item.id).join(",")
          );
        }
      }

      if (this.selectedFilter.content) {
        if (this.selectedFilter.content.length > 0) {
          params.append(
            "contentList",
            this.selectedFilter.content.map((item) => item.id).join(",")
          );
        }
      }

      if (this.selectedFilter.subject) {
        if (this.selectedFilter.subject.length > 0) {
          params.append(
            "subjectList",
            this.selectedFilter.subject.map((item) => item.id).join(",")
          );
        }
      }
      if (this.selectedFilter.users) {
        params.append("users", this.selectedFilter.users.value);
      }

      if (this.selectedFilter.highlights) {
        params.append("highlights", true);
      }
      if (this.selectedFilter.inLive) {
        params.append("inLive", true);
      }

      if (this.selectedFilter.important) {
        params.append("important", true);
      }

      if (this.selectedFilter.exclusive) {
        params.append("exclusive", true);
      }
      if (this.selectedFilter.attachment) {
        params.append("attachment", true);
      }
      if (this.selectedFilter.video) {
        params.append("video", true);
      }
      if (this.selectedFilter.audio) {
        params.append("audio", true);
      }
      if (this.selectedFilter.relevant) {
        params.append("relevant", true);
      }
      if (this.selectedFilter.disclosureAnnouncement) {
        params.append("disclosureAnnouncement", true);
      }
      if (this.selectedFilter.disclosureInvite) {
        params.append("disclosureInvite", true);
      }
      if (this.selectedFilter.podcast) {
        params.append("podcast", true);
      }

      if (this.selectedFilter.selectFilterDate) {
        if (
          this.selectedFilter.selectFilterDate ==
          AppConstants.FILTER_DATE_OPTION.Others
        ) {
          if (this.selectedFilter.fromDate) {
            // console.log('fromDate: ', convertDatetimeHelper.convertDateToStringFormatFrom(this.selectedFilter.fromDate));
            params.append(
              "fromDate",
              convertDatetimeHelper.convertDateToStringFormatFrom(
                this.selectedFilter.fromDate
              )
            );
          }
          if (this.selectedFilter.toDate) {
            // console.log('toDate: ', convertDatetimeHelper.convertDateToStringFormatTo(this.selectedFilter.toDate));
            params.append(
              "toDate",
              convertDatetimeHelper.convertDateToStringFormatTo(
                this.selectedFilter.toDate
              )
            );
          }
        } else {
          const dt = convertDatetimeHelper.getFilterDateParams(
            this.selectedFilter.selectFilterDate
          );
          if (dt) {
            params.append("fromDate", dt);
          }
        }
      }
      return params;
    },
    loadReportData() {
      this.displayNotFountReportData = false;
      this.currentPage = 1;
      this.reportsData = [];
      this.updateRefreshActive(true);

      this.$vs.loading({
        container: "#email-app",
        scale: 0.6,
      });
      if (!this.isAuthenticated) {
        const locale = this.$i18n.locale;
        const params = new URLSearchParams();
        if (this.currentContent && this.currentContent.id) {
          params.append("content", this.currentContent.id);
        } else {
          params.append("content", 0);
        }
        params.append("commodity", this.currentCommodity.id);
        params.append("country", getLocaleCode(locale));
        newsHomeService
          .getAllCache(params)
          .then((response) => {
            try {
              this.$vs.loading.close("#email-app > .con-vs-loading");
            } catch (error) {
              console.log("[loadReportData][$vs.loading]", error);
            }
            // console.log(response);
            this.reportsData = response;
            this.totalPages = 1;
            this.totalResults = 0;
            if (response.length === 0) {
              this.displayNotFountReportData = true;
              this.openDetail(null);
            } else if (
              this.isDesktop &&
              !this.isMosaicView &&
              !this.isCalendarView
            ) {
              this.openViewByScreenSize(this.reportsData[0]);
              // this.openDetail(this.reportsData[0]);
              // if (!this.reportDetail)  {
              // }
            }
            setTimeout(() => this.updateRefreshActive(false), 900);
          })
          .catch((error) => {
            this.displayNotFountReportData = true;
            this.updateRefreshActive(false);
            console.log(error);
          });
      } else {
        reportService
          .getAllReportsByCommodity(this.buildSearchParams())
          .then((response) => {
            try {
              this.$vs.loading.close("#email-app > .con-vs-loading");
            } catch (error) {}
            // console.log(response);
            this.reportsData = response.data;
            this.totalPages = response.totalPages;
            this.totalResults = response.totalResults || 0;

            // console.log('[loadedNewsDetail]',this.loadedNewsDetail)
            if (response.data.length === 0) {
              this.displayNotFountReportData = true;
              if (!this.isCalendarView) {
                this.openDetail(null);
              }
            } else if (
              this.isDesktop &&
              !this.isMosaicView &&
              !this.isCalendarView &&
              !this.loadedNewsDetail &&
              this.reportsData[0]
            ) {
              this.openViewByScreenSize(this.reportsData[0]);
              // this.openDetail(this.reportsData[0]);
            }
            setTimeout(() => this.updateRefreshActive(false), 900);
          })
          .catch((error) => {
            this.displayNotFountReportData = true;
            this.updateRefreshActive(false);
            console.log(error);
          });
      }
    },
    loadReportTickers() {
      if (this.isAuthenticated && this.canDisplayTicker) {
        this.newsTickerData = [];
        reportService
          .getNewsTicker(this.buildTickerSearchParams())
          .then((response) => {
            this.newsTickerData = response.data;
          })
          .catch((error) => console.log(error));
      }
    },
    loadReportHighlights() {
      if (this.isAuthenticated) {
        this.canDisplayHighlight = false;
        const params = new URLSearchParams();
        params.append("page", "1");
        params.append("limit", AppConstants.HIGHLIGHTS_DEFAULT_CAROUSEL_LIMIT);
        params.append("highlights", true);

        params.append("commodity", this.currentCommodity.id);
        params.append("originCode", this.currentCommodity.originCode);

        if (this.currentContent && this.currentContent.id) {
          params.append("content", this.currentContent.id);
        }
        if (this.selectedFilter.content) {
          if (this.selectedFilter.content.length > 0) {
            params.append(
              "contentList",
              this.selectedFilter.content.map((item) => item.id).join(",")
            );
          }
        }

        if (this.selectedFilter.subject) {
          if (this.selectedFilter.subject.length > 0) {
            params.append(
              "subjectList",
              this.selectedFilter.subject.map((item) => item.id).join(",")
            );
          }
        }

        this.reportsDataHighlights = [];
        reportService
          .getAllReportsByCommodity(params)
          .then((response) => {
            //   console.log(response);
            this.reportsDataHighlights = response.data;
            this.canDisplayHighlight = true;

            if (
              this.reportsData.length == 0 &&
              !this.reportDetail &&
              response.data.length > 0 &&
              this.isDesktop
            ) {
              if (
                !this.isMosaicView &&
                !this.isCalendarView &&
                !this.loadedNewsDetail &&
                this.reportsDataHighlights[0]
              ) {
                this.openViewByScreenSize(this.reportsDataHighlights[0]);
              } else {
                this.openDetail(this.reportsDataHighlights[0]);
              }
              this.displayViewByScreenSize();
            }
          })
          .catch((error) => console.log(error));
      } else {
        const locale = this.$i18n.locale;
        const params = new URLSearchParams();
        if (this.currentContent && this.currentContent.id) {
          params.append("content", this.currentContent.id);
        } else {
          params.append("content", 0);
        }
        params.append("commodity", this.currentCommodity.id);
        params.append("country", getLocaleCode(locale));
        newsHomeService
          .getAllCacheHighlights(params)
          .then((response) => {
            this.reportsDataHighlights = response;
            this.canDisplayHighlight = true;
          })
          .catch((error) => {
            this.displayNotFountReportData = true;
            console.log(error);
          });
      }
    },
    loadFilters() {
      this.displayFilters = false;
      this.filters.characteristic = [];
      this.filters.periodicity = [];
      this.filters.country = [];
      this.filters.topic = [];
      this.filters.exclusive = false;
      if (!this.isAuthenticated) {
        this.displayFilters = true;
      } else {
        const params = new URLSearchParams();
        params.append("commodity", this.currentCommodity.id);
        // params.append("originCode", this.currentCommodity.originCode);
        if (this.currentContent && this.currentContent.id) {
          params.append("content", this.currentContent.id);
        }

        reportService
          .getFilters(params)
          .then((response) => {
            this.filters.characteristic = response.characteristic;
            this.filters.periodicity = response.periodicity;
            this.filters.country = response.country;
            this.filters.exclusive = response.exclusive;
            this.filters.topic = response.topic;
            this.displayFilters = true;
          })
          .catch((error) => console.log(error));
      }
    },
    loadContentList() {
      // this.maximizeDetail(false);
      this.loadedNewsDetail = false;
      this.displayFilters = false;
      this.contents.analysis = [];
      this.contents.quotes = [];
      this.contents.favorites = [];
      const params = new URLSearchParams();
      params.append("commodity", this.currentCommodity.id);
      if (!this.isAuthenticated) {
        newsHomeService
          .getAllContentCache(params, this.isDesktop)
          .then((response) => {
            this.contents.analysis = response.analysis;
            this.contents.quotes = response.quotes;
            this.displayFilters = true;
            this.checkCurrentContentHasInCurrentCommodity();
            this.loadReportData();
            this.loadReportHighlights();
          })
          .catch((error) => console.log(error));
      } else {
        params.append("originCode", this.currentCommodity.originCode);
        reportService
          .getCommodityConfigFilter(params, this.isDesktop)
          .then((response) => {
            this.contents.analysis = response.analysis;
            this.contents.quotes = response.quotes;
            this.contents.favorites = response.favorites;

            // check if current content has rights -> need this verification when change commodity
            this.checkCurrentContentHasInCurrentCommodity();

            if (this.currentContent && this.currentContent.id) {
              // update content from response
              let cont = this.contents.analysis.find(
                (item) => item.id == this.currentContent.id
              );
              if (!cont) {
                cont = this.contents.quotes.find(
                  (item) => item.id == this.currentContent.id
                );
                if (!cont) {
                  cont = this.contents.favorites.find(
                    (item) => item.id == this.currentContent.id
                  );
                }
              }
              if (cont) {
                this.$store.dispatch("updateCurrentContent", cont);
                this.updateHeaderMobileCurrentContent();
              }
            }

            // console.log('[currentContent]', this.currentContent)

            if (this.currentContent.isQuotes) {
              this.openQuotesPage(true);
              this.openAskAnalystPage(false);
              this.openWeatherPage(false);
              this.openDetail(null);
              this.reportViewActive(false);
              this.displayFilters = true;

              if (this.isWindowDetached) {
                this.updateReduceSidebar(true);
              }
              return;
            }

            if (this.currentContent.id == CONTENT.ASK_ANALYST) {
              this.openQuotesPage(false);
              this.openAskAnalystPage(true);
              this.displayFilters = true;
              return;
            }
            if (this.currentContent.id == CONTENT.WEATHER) {
              if (
                this.currentReportType &&
                this.currentReportType.id &&
                this.currentReportType.id != 1
              ) {
                this.openQuotesPage(false);
                this.openAskAnalystPage(false);
                this.openWeatherPage(true);
                // this.openDetail(null);
                this.displayFilters = true;
                return;
              }
            }
            if (this.isWhatsItContent) {
              this.openQuotesPage(false);
              this.openAskAnalystPage(false);
              this.openWeatherPage(false);
              this.displayFilters = true;
              return;
            }
            if (this.currentContent.id == CONTENT.CALENDAR) {
              this.changeToCalendarView();
            }

            this.loadReportData();
            this.loadReportHighlights();
            // this.loadReportTickers();
            this.loadFilters();
            this.displayFilters = true;
          })
          .catch((error) => console.log(error));
      }
    },
    checkCurrentContentHasInCurrentCommodity() {
      if (this.currentContent.id) {
        // check if current content has rights -> need this verification when change commodity
        const contentFinded = this.contentList.find(
          (item) => item.id == this.currentContent.id
        );
        if (!contentFinded || !contentFinded.habilitado) {
          this.$store.dispatch("updateCurrentContentToDefault");
          this.openQuotesPage(false);
          this.openAskAnalystPage(false);
          this.openWeatherPage(false);
          this.updateHeaderMobileCurrentContent();
          if (this.isCalendarView) {
            this.mosaicView();
          }
        }
      }
    },
    updateHeaderMobileCurrentContent() {
      EventBus.$emit(
        AppConstants.BUS_EVENT_HEADER_MOBILE_SELECT_INFORMATIVE_CONTENT_FILTER,
        this.currentContentName
      );
    },
    reloadDataWithFilter: function (filterData) {
      console.log("[reloadDataWithFilter]");
      this.closePlaylist();
      this.loadedNewsDetail = false;
      this.maximizeDetail(false);
      this.onBackToTop();
      if (filterData.previousContent) {
        this.previousContent = filterData.previousContent;
      }
      // this.selectedFilter = null;
      if (filterData.selectedFilter) {
        this.selectedFilter = JSON.parse(
          JSON.stringify(filterData.selectedFilter)
        );
      }
      if (this.previousContent && this.previousContent.id == 24) {
        generalHelper.clearFilterFields(this.selectedFilter);
        this.clearSearchQuery();
      }
      this.$forceUpdate();
      this.updateHeaderMobileCurrentContent();

      EventBus.$emit(
        AppConstants.BUS_EVENT_UPDATE_NUM_FILTER_MOBILE,
        this.displayFilterBadgeSelected()
      );
      // if (this.isWindowDetached) {
      //   console.log('[reloadDataWithFilter] window detached')
      //   this.$router.push({name: 'informative', params: {commodity: this.currentCommodity.id} , query: {currentCommodity: this.currentCommodity.id, currentContent: this.currentContent.id}});
      //   // this.$router.replace({name: 'informative', query: {currentContent: this.currentContent.id}});
      // }

      // TODO - TEMPORARIO - Tratamento para clima - id 12 hardcode
      if (this.currentContent.id == CONTENT.WEATHER) {
        if (
          this.currentReportType &&
          this.currentReportType.id &&
          this.currentReportType.id != 1
        ) {
          this.openQuotesPage(false);
          this.openAskAnalystPage(false);
          this.openWeatherPage(true);
          // this.openDetail(null);
          console.log("[WEATHER] ", this.currentReportType);
          return;
        }
      }

      // Tratamento para o fale com analista - id 11 hardcode
      if (this.currentContent.id == CONTENT.ASK_ANALYST) {
        this.openQuotesPage(false);
        this.openAskAnalystPage(true);
        this.openWeatherPage(false);
        this.openDetail(null);
        this.reportViewActive(false);
        return;
      }
      // Tratamento para Cotação
      if (this.currentContent.isQuotes) {
        this.openAskAnalystPage(false);
        this.openQuotesPage(true);
        this.openWeatherPage(false);
        this.openDetail(null);
        this.reportViewActive(false);
        return;
      }
      if (this.isWhatsItContent) {
        this.openAskAnalystPage(false);
        this.openQuotesPage(false);
        this.openWeatherPage(false);
        return;
      }
      this.openAskAnalystPage(false);
      this.openQuotesPage(false);
      this.openWeatherPage(false);
      if (this.isMosaicView || this.isCalendarView) {
        this.reportViewActive(false);
      }
      console.log("[this.currentContent.id]", this.currentContent);
      if (this.currentContent.id == CONTENT.CALENDAR) {
        // this.loadReportData();
        this.changeToCalendarView();
        if (this.$refs["calendarComponent"]) {
          this.$refs["calendarComponent"].reloadDataWithFilters(
            this.selectedFilter
          );
        }
        return;
      } else if (this.isCalendarView) {
        if (this.isDesktop) {
          this.mosaicView();
        } else {
          this.listViewDetailed();
          this.openDetail(null);
        }
      }
      // this.reportsData = []; // TODO - ver se precisa mesmo comentar isso
      // this.changeScrollY = false;
      // this.isReportViewSidebarActive = false;
      this.loadReportData();
      this.loadReportHighlights();
      if (!this.isDesktop) {
        this.reportViewActive(false);
      }
    },
    toggleIsStarred() {
      const payload = {
        mailId: this.currentMail.id,
        value: !this.currentMail.isStarred,
      };
      this.$store.dispatch("email/toggleIsMailStarred", payload);
    },
    nextReport(currentData) {
      console.log("nextReport");
      if (this.reportDetail) {
        const index = this.reportsData.findIndex(
          (item) => item.uuid == currentData.uuid
        );
        if (index >= 0) {
          index++;
          if (index <= this.reportsData.length) {
            this.openDetail(this.reportsData[index]);
          }
        }
      }
    },
    previousReport() {
      console.log("previousReport");
      if (this.reportDetail) {
        const index = this.reportsData.findIndex(
          (item) => item.uuid == currentData.uuid
        );
        if (index >= 0) {
          index--;
          if (index <= this.reportsData.length) {
            this.openDetail(this.reportsData[index]);
          }
        }
      }
    },
    setSidebarWidth() {
      if (this.windowWidth < 1600) {
        this.updateReduceSidebar(true);
      } else {
        this.updateReduceSidebar(false);
      }
      this.displayViewByScreenSize();
    },
    loadMorePage() {
      this.displayLoadInBtn = true;
      this.$vs.loading({
        container: "#informative-content",
        scale: 0.6,
        background: "transparent",
      });
      this.currentPage++;
      this.updateRefreshActive(true);

      if (!this.isAuthenticated) {
        // TODO - Verificar se terá paginação
        this.$vs.loading.close("#informative-content > .con-vs-loading");
        this.displayLoadInBtn = false;
        this.perfectScrollbarReachEnd = false; // reset loading
        setTimeout(() => this.updateRefreshActive(false), 900);
      } else {
        reportService
          .getAllReportsByCommodity(this.buildSearchParams())
          .then((response) => {
            this.reportsData = this.reportsData.concat(response.data);
            this.totalPages = response.totalPages;
            try {
              this.$vs.loading.close("#informative-content > .con-vs-loading");
            } catch (error) {
              console.log("[$vs.loading]", error);
            }
            this.displayLoadInBtn = false;
            this.perfectScrollbarReachEnd = false; // reset loading
            setTimeout(() => this.updateRefreshActive(false), 900);
          })
          .catch((error) => {
            console.log(error);
            this.updateRefreshActive(false);
            this.currentPage--;
          });
      }
    },
    loadNewsDetail(id) {
      if (this.isAuthenticated) {
        // console.log('[loadNewsDetail]', id);
        this.reportDetail = null;
        this.closeReportViewSidebar();
        reportService
          .getNewsDetail(id, new URLSearchParams())
          .then((resp) => {
            this.openDetail(resp, true);
          })
          .catch((err) => console.log(err));
      }
    },
    loadEventScheduleRelatedNews(data) {
      this.reportDetail = null;
      this.closeReportViewSidebar();
      reportService
        .getNewsDetail(data._id, new URLSearchParams())
        .then((resp) => {
          this.openDetail(resp);
        })
        .catch((err) => console.log(err));
    },

    getRelatedNews(report) {
      if (!this.isAuthenticated) return;
      let params = new URLSearchParams();

      params.append("reportId", report._id);

      if (
        report.related_news &&
        report.related_news.news &&
        report.related_news.news.length > 0
      ) {
        let registeredRelatedNewsIds = [];
        for (let index = 0; index < report.related_news.news.length; index++) {
          registeredRelatedNewsIds.push(report.related_news.news[index]._id);
        }
        params.append(
          "registeredRelatedNewsIds",
          registeredRelatedNewsIds.join(",")
        );
      }

      if (report.tagsSearch && report.tagsSearch > 0) {
        let tagSearchString = report.tagsSearch.join(",");
        params.append("tagsSearch", tagSearchString);
      }

      if (report.hat && report.hat.length > 0) {
        let hatName = report.hat.map((item) => item.name).join(",");
        params.append("hat", hatName);
      }

      params.append("title", report.content.title.data);

      const newsContentCode = report.newsContent.map((item) => item.code);
      params.append("newsContentCode", newsContentCode);

      const subjectCode = report.subjects.map((item) => item.code);
      params.append("subjectCode", subjectCode);

      const countryCode = report.country.map((item) => item.code);
      params.append("countryCode", countryCode);

      if (
        report.related_news &&
        report.related_news.news &&
        report.related_news.news.length == 0
      ) {
        params.append("limit", 3);
      } else if (
        report.related_news &&
        report.related_news.news &&
        report.related_news.news.length == 1
      ) {
        params.append("limit", 2);
      } else if (
        report.related_news &&
        report.related_news.news &&
        report.related_news.news.length == 2
      ) {
        params.append("limit", 1);
      } else {
        params.append("limit", 3);
      }

      reportService
        .getRelatedNews(params)
        .then((resp) => {
          resp.forEach((item) => {
            if (!this.relatedNews.news) {
              this.relatedNews.news = [];
            }
            this.relatedNews.news.push(item);
          });
          this.$refs["informative-view"].updateRelatedNewsData(
            this.relatedNews
          );
        })
        .catch((err) => console.log(err));
    },

    searchRelatedNews(report) {
      if (!this.isAuthenticated) return;
      if (!report) return;
      this.relatedNews.news = [];
      this.relatedNews.free_text = "";
      this.relatedNews.free_title = "";
      if (report.related_news && report.related_news.free_text) {
        this.relatedNews.free_text = report.related_news.free_text;
      }
      if (report.related_news && report.related_news.free_title) {
        this.relatedNews.free_title = report.related_news.free_title;
      }
      if (
        report.related_news &&
        report.related_news.news &&
        report.related_news.news.length > 0
      ) {
        for (let index = 0; index < report.related_news.news.length; index++) {
          let news = {
            id: report.related_news.news[index]._id,
            title: report.related_news.news[index].content.title.data,
          };
          this.relatedNews.news.push(news);
        }
        if (this.relatedNews.news.length < 3) {
          this.getRelatedNews(report);
        } else {
          this.$refs["informative-view"].updateRelatedNewsData(
            this.relatedNews
          );
        }
      }
      if (
        !report.related_news ||
        !report.related_news.news ||
        report.related_news.news.length == 0
      ) {
        this.getRelatedNews(report);
      }
    },

    sendReadNews(report) {
      if (!this.isAuthenticated) return;
      if (!report) return;
      reportService
        .sendReadNews(report._id, new URLSearchParams())
        .then(() => {})
        .catch((err) => console.log(err));
    },

    openDetail(report, openNewsDetail = false, weatherDetail = false) {
      if (weatherDetail) {
        this.reportDetail = null;
        this.relatedNews = {};
        this.reportViewActive(true);
        if (!this.isDesktop) {
          this.$refs["informative-view"].openMobileDetails(true);
        }
        return;
      }
      // console.log('[OPEN_DETAIL]');
      if (
        !this.isDesktop &&
        !this.isAuthenticated &&
        report &&
        !report.displayDetail
      ) {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP);
        return;
      }
      let isEqualSelectedItem = false;
      if (this.reportDetail && this.reportDetail._id && report) {
        isEqualSelectedItem = this.reportDetail._id == report._id;
      }
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_AUTHOR_DETAIL, null);
      this.reportDetail = null;
      // console.log('[OPEN_DETAIL] reset reportDetail', report);
      // reset text to speech
      // if (!report) this.reportDetail = null;
      this.loadedNewsDetail = openNewsDetail;
      // console.log('details: ', this.$refs['informative-view'].pdfViewerMobile)
      this.reportDetail = report;
      this.relatedNews = {};
      if (!isEqualSelectedItem) {
        this.searchRelatedNews(report);
        this.sendReadNews(report);
      }
      // console.log('[OPEN_DETAIL] load reportDetail');
      // console.log(this.isReportViewSidebarActive);
      // this.isReportViewSidebarActive = false;
      this.reportViewActive(true);
      // if (this.isDesktop && !this.isMosaicView) {}
      if (!this.isDesktop) {
        setTimeout(() => {
          this.$refs["informative-view"].openMobileDetails(true);
        }, 300);
      }
    },
    openFilter() {
      this.sidebarFilterActive = true;
    },
    selectCurrentContent(content) {
      console.log("[selectCurrentContent]", content);
      if (content.isLabel) return;
      if (!content.habilitado) {
        this.openUserRightsModal(content);
        return;
      }
      if (
        content.isQuotes &&
        (!this.isAuthenticated || !content.quotesDisplayDetail)
      ) {
        // console.log('[quotesDisplayDetail]');
        this.displayExclusiveContent();
        this.displayPopupContentFilterMobile = false;
        return;
      }
      if (content.reportType && content.reportType.length > 0) {
        this.mobileContentListTabIndex = 1;
      } else {
        this.mobileContentListTabIndex = 0;
        this.displayPopupContentFilterMobile = false;
        this.$store.dispatch("updateCurrentReportType", { id: null });
      }

      this.$store.dispatch("updateCurrentContent", content);
      this.updateHeaderMobileCurrentContent();
      this.reloadDataWithFilter({ selectedFilter: this.selectedFilter });
    },
    isContentFilterSelected(item) {
      if (this.currentContent) {
        return this.currentContent.id == item.id;
      }
      return false;
    },
    closeFilter() {
      this.sidebarFilterActive = false;
    },
    updateListContentFav(content) {
      this.addOrRemoveContentFromList(content);
      this.$forceUpdate();
    },
    async favoriteContentListMobile(contentList) {
      const form = {
        favContent: {
          subjectCode: this.currentCommodity.id,
          // contentCode: contentList.map(item => item.id).join(',')
          contentCode: contentList.id,
        },
      };
      await layoutService.saveLayout(form, new URLSearchParams());
      this.loadContentList();
    },
    async addOrRemoveContentFromList(content) {
      // remove or add favorites
      // const favIndex = this.contents.favorites.findIndex(item => item.id == content.id);
      // if (favIndex > 0) { // remove
      //   this.contents.favorites.splice(favIndex, 1);
      // } else { // add
      //   this.contents.favorites.push(content);
      //   // this.contents.favorites = this.contents.favorites.slice().sort((a, b) => {
      //   //   return a.ordem - b.ordem;
      //   // });
      // }
      const form = {
        favContent: {
          subjectCode: this.currentCommodity.id,
          contentCode: content.id,
        },
      };
      await layoutService.saveLayout(form, new URLSearchParams());
      this.loadContentList();
    },
    updateCurrentCommodityFromParams() {
      if (this.isAuthenticated) {
        const menuItems = menuBuilderHelper.buildMenu(
          localStorageHelper.getCurrentUser().rights
        );
        if (this.$route.params.commodity) {
          const commodity = menuItems[0].items.find(
            (item) => Number(item.id) == Number(this.$route.params.commodity)
          );
          if (commodity) {
            this.$store.dispatch("updateCurrentCommodity", commodity);
            return;
          }
        }
        // get default menu item (first item in menu)
        this.$store.dispatch("updateCurrentCommodity", menuItems[0].items[0]);
        this.$router.push({
          path: `${menuBuilderHelper.getInformativePageFirstItemMenu()}`,
        });
      }
    },
  },
  components: {
    BButton,
    Calendar,
    InformativeItem,
    InformativeListItem,
    InformativeCardItem,
    InformativeMosaicItem,
    InformativeSidebar,
    VuePerfectScrollbar,
    InformativeView,
    InformativeHighlights,
    InformativeHighlightsMosaic,
    InformativeHighlightsFullscreen,
    AskTheAnalyst,
    InformativeFilter,
    TMNQuotes,
    DropdownUserInfo,
    WhatIsIt,
    CustomContent,
    PrivateContent,
    "vue-pull-refresh": VuePullRefresh,
    MenuContentMobile,
    InformativeCalendar,
    Tickers,
  },
  created() {
    this.tickerInterval = setInterval(() => {
      this.loadReportTickers();
    }, 45000);

    // check if currentCommodity exist
    console.log("[currentcommodity]", this.$store.state.currentCommodity);

    window.addEventListener("beforeunload", this.closeTmnWindow);
    // document.getElementById("<informative-scroll>").addEventListener('scroll', this.onScroll);

    // this.$store.state
    // this.commodityId = this.$route.params.commodity;

    // this.debouncedGetAnswer = _.debounce(this.loadReportData, 500);
    // load sidebar reduce value from localstorage
    this.setSidebarWidth();
    this.updateReduceSidebar(localStorageHelper.getSidebarInformativeReduce());
    // this.reduceSidebar = localStorageHelper.getSidebarInformativeReduce();

    // this.loadContentList();

    // pooling refresh
    if (this.isAuthenticated) {
      this.refreshPooling = setInterval(() => {
        this.refreshReports();
      }, this.$config.timePoolingReportRefresh);
    }

    setTimeout(() => {
      if (!this.isDesktop && !this.loadedNewsDetail) {
        this.reportViewActive(false);
      } else if (!this.isMosaicView && !this.isCalendarView) {
        this.displayViewByScreenSize();
      }

      if (this.isWindowDetached) {
        this.$store.dispatch("updateSubscribeToolsVisibility", false);
        this.$store.dispatch("updateNavMenuVisibility", false);
        this.updateReduceSidebar(true);
        setTimeout(() => {
          EventBus.$emit(AppConstants.BUS_EVENT_TOGGLE_REDUCE_MAIN_MENU, true);
        }, 3000);
      }
    }, 500);
  },
  mounted() {
    console.log("[informative][mounted]");
    this.loadReportTickers();

    this.searchQuery = this.$route.query.q;

    this.updateBackgroundQuotesPageVisibility();

    if (this.$store.state.insetTop || this.$store.state.insetBottom) {
      let styleTag = document.getElementById("sidebar-filter-inset-overrides");
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = "sidebar-filter-inset-overrides";
        document.head.appendChild(styleTag);
      }
      styleTag.textContent = `
      .sidebar-filter-mobile .vs-sidebar{
        top: ${this.$store.state.insetTop}px !important;
        bottom: ${this.$store.state.insetBottom}px !important;
        height: auto !important;
        max-height: 100% !important;
      }

      .sidebar-filter-mobile .vs-sidebar .vs-sidebar--items div #body-filter .mobile-filter-header {
        top: ${this.$store.state.insetTop}px !important;
      }

    `;
    }

    // EVENTS
    EventBus.$on(AppConstants.BUS_EVENT_REFRESH, () => {
      if (this.isAuthenticated) {
        this.refreshReports();
      } else {
        this.loadReportData();
      }
    });

    EventBus.$on(AppConstants.BUS_EVENT_CLOSE_POPUP, () => {
      this.displayPopupContentFilterMobile = false;
      this.closeReportViewSidebar();
      this.reportDetail = null;
    });

    EventBus.$on(
      AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_FILTER,
      () => {
        this.openFilter();
      }
    );

    EventBus.$on(
      AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_CONTENT_FILTER,
      () => {
        this.displayPopupContentFilterMobile = true;
      }
    );

    EventBus.$on(AppConstants.BUS_EVENT_OPEN_NEWS_DETAIL, (val) => {
      if (this.isAuthenticated) {
        const menuItems = menuBuilderHelper.buildMenu(
          localStorageHelper.getCurrentUser().rights
        );
        const commodity = menuItems[0].items.find(
          (item) => Number(item.id) == Number(val.commodity)
        );
        if (commodity) {
          this.$store.dispatch("updateCurrentCommodity", commodity);
        }
        this.loadNewsDetail(val.id);
      }
    });

    if (!this.isDesktop) {
      EventBus.$on(
        AppConstants.BUS_EVENT_SEARCH_INFORMATIVE_MOBILE,
        (query) => {
          this.searchQuery = query;

          this.$router.push({ query: { q: this.searchQuery } });
        }
      );
    }

    EventBus.$on(AppConstants.BUS_EVENT_OPEN_REPORT_DETAIL, (data) => {
      this.openDetail(data);
    });

    setTimeout(() => {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_TOUR, true);
    }, 2000);

    // check on params if has news ID
    // console.log('[params]', this.$route.params.id)

    // console.log('[rights]', localStorageHelper.getCurrentUser().rights)

    this.updateCurrentCommodityFromParams();
    if (this.paramsNewsID) {
      this.loadNewsDetail(this.paramsNewsID);
    }

    try {
      // if (!this.isDesktop) {
      if (checkDeviceTypeHelper.isNativeApp()) {
        console.log("[mounted][appMounted] sending postMessage");
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              action: "appMounted",
            })
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.closeTmnWindow);
    this.closeTmnWindow();

    // stop listening event
    EventBus.$off(AppConstants.BUS_EVENT_UPDATE_HIGHLIGHTS);
    EventBus.$off(AppConstants.BUS_EVENT_CLOSE_POPUP);
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_FILTER);
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_REPORT_DETAIL);
    EventBus.$off(
      AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_CONTENT_FILTER
    );
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_NEWS_DETAIL);
    EventBus.$off(AppConstants.BUS_EVENT_REFRESH);
    EventBus.$off(AppConstants.BUS_EVENT_DISPLAY_TICKER);

    if (!this.isDesktop) {
      EventBus.$off(AppConstants.BUS_EVENT_SEARCH_INFORMATIVE_MOBILE);
    }
    clearInterval(this.refreshPooling);
    clearInterval(this.tickerInterval);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.empty-report {
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  margin-top: 20px;
  background-color: rgba(255, 186, 0, 0.09);
  border-color: #ffba00;
  color: #cc9500;
  padding: 20px;
  margin: 20px;
  border: 1px solid #ddd;
}

.full-height {
  height: 100%;
}

.informative-header {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 145px;
  margin-top: -6px;
  width: auto;
  margin-left: -16px;
  margin-right: 0px;
  margin-bottom: 0px;
}

.informative-header-empty {
  margin-top: 4px;
  margin-left: -15px;
  width: 103%;
}

.all-commodities-header-empty {
  width: 115%;
  margin-left: 0px;
  background-position-y: -4px;
}

.informative-header-desktop {
  transition: 0.4s;
  overflow: hidden;
  position: fixed;
  width: calc(100% - 270px);
  z-index: 999;
}

.informative-header-desktop-sidebar-reduced {
  width: calc(100% - 100px);
  margin-left: -18px;
}

.informative-background h1 {
  transition: 0.4s;
  color: #000000;
  // font-family: "Roboto", sans-serif !important;
  font-weight: bold;
  font-size: calc(18px + (31 - 18) * ((100vw - 270px) / (1700 - 300)));
}

.theme-dark .informative-background h1 {
  color: #fff !important;
}

.theme-dark .informative-background p {
  color: #fff !important;
}

.informative-background p {
  color: #000000 !important;
}

.informative-background {
  float: left;
  background-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0),
    rgb(255, 255, 255)
  );
  width: 600px;
  padding: 10px 0px 10px 10px;
  justify-content: center;
  margin: 35px 10px 10px 12px;
}

.informative-background-mobile {
  width: 230px;
}

.theme-dark .informative-background {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0), #2f363d);
}

.informative-subtitle {
  font-size: 10px;
  font-weight: 600;
}

.load-more-loading-area {
  width: 100%;
  height: 50px;
  display: none;
}

.theme-dark #content-filter-mobile-popup .vs-tabs-position-left .vs-tabs--ul {
  background-color: #353e45;
}

#content-filter-mobile-popup {
  .vs-popup--content {
    margin-top: 0px;
  }

  .vs-popup--header {
    display: none;
    background-color: #fff;
  }

  .vs-popup {
    width: 100%;
    height: 100%;
  }
}

.sidebar-filter-mobile {
  .vs-sidebar {
    max-width: 100%;
    z-index: 99999;
  }
}
.sidebar-filter-mobile .filter-scroll-area {
  padding: 0 25px;
  margin-bottom: 50px;
  margin-top: 50px;
}
.report-list-no-highliths {
  // margin-top: 138px;
}

.report-list-with-highliths {
  margin-top: 135px;
}

.commodity-img-nav-scroll {
  height: 60px !important;

  .informative-background {
    margin-top: 1px;
    padding-top: 6px;
  }

  .informative-background h1 {
    font-size: calc(2px + (31 - 18) * ((100vw - 270px) / (1700 - 300)));
  }
}

.info-content-desktop {
  // height: calc(100vh - 60px);
  // height: calc(100vh);
  height: 100%;
  width: 100%;
  margin-left: 215px;
}
.info-content-desktop-with-ticker {
  // height: calc(100vh);
  height: calc(100%);
}
.info-content-desktop-with-ticker-top {
  height: calc(100% - 200px);
}
.quotes-content-desktop {
  // width: 85%;
  width: 100%;
  // width: calc(85% - 5px);
  height: calc(100vh - 10px);
}
.cardview-desktop {
  // height: calc(100vh - 15px);
  // height: calc(100vh - 60px);
  height: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: fill-available;
  // width: 35%;
  margin-left: 230px;
  @media (max-width: 520px) {
    margin-left: 0px;
  }
  width: calc(100% - 230px);
}
// .cardview-desktop-reduced {
//   width: -webkit-fill-available;
// }

.info-sidebar-desktop .vs-sidebar {
  width: 230px;
  max-width: 270px;
  z-index: 99999;
}

.sidebar-spacer-toggled {
  margin-left: 54px;
  width: calc(100% - 60px);
}

.content-btn-informative-back-to-top {
  transition: all 0.6s ease;
  position: sticky;
  float: right;
  bottom: 0px;
  padding-bottom: 15px;
  margin-right: 15px;
  .btn-back-to-top {
  }
}

.fade-in {
  opacity: 1;
}

.fade-out {
  opacity: 0;
}

.input-search-all {
  justify-content: left;
  margin-left: 245px;

  .search-field-content {
    // width: 100%;
    // width: 30%;
    margin-right: 15px;
    display: flex;
  }

  .icons-tools-wrap {
    padding: 5px;
  }

  .icons-tools-wrap .dropdown-user {
    height: 100%;
    width: auto;
  }

  .icons-tools-wrap:hover svg {
    font-size: 2.9rem;
    -ms-transform: scale(1.3);
    transform: scale(1.3);
    cursor: pointer;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }

  span.icons-tools-wrap.view-style-selected {
    // color: #99CF16;
    // font-size: 2.9rem;
    -ms-transform: scale(1.3);
    transform: scale(1.3);
    cursor: pointer;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }

  span.icons-tools-wrap.dropdown-filter-visible {
    // color: #99CF16;
    // font-size: 2.9rem;
    -ms-transform: scale(1.3);
    transform: scale(1.3);
    cursor: pointer;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }

  .close-icon {
    margin-right: 20px;
  }

  .vs-con-dropdown {
    width: 50px;
    height: 40px;

    a i {
      font-size: 24px;
      margin-left: 0px;
      margin-top: 3px;
      width: 10px;
      margin-right: 17px;
    }

    a .feather-icon {
      // margin-top: 8px;
    }

    a .search-icon {
      margin-left: 2px;
    }

    a .chevron-down-icon {
      margin-left: 1px;
      margin-top: 1px;
    }
  }
}

.theme-dark .icons-tools-wrap.view-style-selected {
  color: white !important;
  background-color: #626262;
}
.theme-dark .icons-tools-wrap.view-style-selected-mobile {
  color: white !important;
  background-color: #626262;
}

.theme-dark .icons-tools-wrap:hover svg {
  color: white !important;
}

.input-search-all-mobile {
  margin-left: 0px;
  margin-bottom: 5px;
}

.input-search-all-reduced {
  margin-left: 58px;
}

.commodity-selected {
  color: rgba(var(--vs-primary), 1) !important;
  background: rgba(var(--vs-primary), 0.01) !important;
}

.highlight-mobile {
  margin-bottom: 5px;
  // margin-top: 5px;
}

.quotes-page-custom {
  .input-search-all {
    display: none !important;
  }

  .info-content-desktop {
    height: calc(100% - 3px);
    margin-top: 0px;
  }
}

.all-commodities-header-mobile {
  background-position-x: -440px;
  background-position-y: 6px;
}

.all-commodities-header-desktop {
  margin-left: 0px;
  background-position-y: -4px;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.card-news {
  min-width: 259px !important;
  padding: 5px !important;

  &:hover {
    transform: translateY(-5px);
    // box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

    .card-img {
      opacity: 0.6;
    }
  }
}

.theme-dark .card-news:hover {
  // background-color: #5B6D4D;
  transition: 0.1s;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.card-news:hover {
  // background-color: #EEEEEE;
  transition: 0.1s;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.vx-row-margin {
  margin: 2px;
}

.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0.5rem;

  // min-height: 235px;
}

.custom-item:hover {
  // background-color: #efefef !important;
  background-color: #efefef !important;
  -webkit-transform: translateY(-5px);
  transform: translateY(-5px);
  -webkit-box-shadow: 0 2px 2px 0 #0000004d;
  box-shadow: 0 2px 2px 0 #4d57624d;
}

.theme-dark .custom-item:hover {
  background-color: #4d5762 !important;
}

.list-item-selected .custom-item {
  background-color: #eaefdf !important;
}
.theme-dark .list-item-selected .custom-item {
  background-color: #4d5762 !important;
}

.custom-carousel .custom-card-carousel .highlight-card:hover {
  background-color: #efefef !important;
  border: 1px solid #ddd;
}
.custom-carousel .highlight-item-selected .highlight-card {
  background-color: #eaefdf;
  border: 1px solid #ddd;
}
.theme-dark .custom-carousel .custom-card-carousel .highlight-card:hover {
  background-color: #4d5762 !important;
}
.theme-dark .highlight-item-selected .highlight-card {
  background-color: #4d5762 !important;
  border-color: #4d5762;
}

.vx-card {
  // background: unset;
}

.multimedia-draggable {
  position: absolute;
  z-index: 999999;
  cursor: move;
  background-color: #d96055;
  bottom: 0px;
  right: 10px;
}

.card-list-view {
  background-color: #f8f8f8;
}

.theme-dark .card-list-view {
  background-color: #2d343b;
}

.view-style-selected svg {
  // fill: #000;
}

.icons-tools.flex.justify-between {
  margin-right: 10px;
  // margin-top: 6px;
}
svg.fullscreenIcon {
  padding-top: 3px;
  padding-left: 3px;
  fill: #626262;
}
svg.icon-refresh {
  margin-top: 4px;
  margin-left: 4px;
}
.theme-dark svg.feather-list {
  stroke: #fff;
}
.theme-dark svg.feather-grid {
  // fill: #FFF;
  stroke: #fff;
}
.theme-dark svg.feather-columns {
  stroke: #fff;
}
.theme-dark svg.fullscreenIcon {
  fill: #fff;
}

.scroll-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  /* display: none; */
}

.refresh-active .pull-down-container {
  opacity: 0.8;
}

/* .refresh-rotate {
  animation: spin 1s infinite linear;
} */

/* @keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} */

/* .scroll-top.show {
  display: block;
} */
</style>
